/* ============================================================
   cpdp.js — Camilla-clone PDP interactions (Horizon theme + static preview)
   Runs in TWO modes:
     • shopify  — real cart via /cart/*.js  (when window.Shopify + config present)
     • demo     — validated mock cart       (static preview / theme editor w/o config)
   Design/behaviour parity: see docs/camilla-pdp-teardown-spec.md
   ============================================================ */
(function(){
  'use strict';
  // Guard: this asset is included by several sections; execute/bind only ONCE.
  if (window.__cpdpInit) return;
  window.__cpdpInit = true;
  const $  = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>[...r.querySelectorAll(s)];
  const money = (cents)=> '$'+(cents/100).toFixed(2);           // shopify money (cents)
  const moneyF = (n)=> '$'+Number(n).toFixed(2);                 // demo money (dollars)
  const esc = (t)=> String(t==null?'':t).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  /* same rule as snippets/hm-product-title.liquid: "Name | What it is" -> just the name (the descriptor isn't displayed) */
  const splitTitle = (t)=>({name:String(t==null?'':t).split('|')[0].trim(), desc:''});

  /* ---------- config (injected by cpdp-main-product.liquid) ---------- */
  const CFG = (()=>{ try{ return JSON.parse($('#cpdp-config')?.textContent||'{}'); }catch(e){ return {}; } })();
  const SHOPIFY = !!(window.Shopify && CFG.variants && CFG.variants.length);

  /* ---------- demo state (used only when !SHOPIFY) ---------- */
  const demo = {
    price: CFG.demoPrice ?? 209.95, compareAt: CFG.demoCompare ?? 239.95,
    giftThreshold: CFG.giftThreshold ?? 150, giftValue: CFG.giftValue ?? 50,
    items: []
  };
  const variant = { color:null, size:null };
  let galleryGoTo = ()=>{};   /* set by initGallery — scrolls the gallery to a media id */
  const variantLabel = ()=> [variant.color, variant.size].filter(Boolean).join(' / ') || 'Select options';

  /* ============ 3. GALLERY ============
     Mobile: edge-to-edge 4:5 swipe carousel with a "1 / 8" counter.
     Desktop: 2-column grid (CSS); choosing a colour moves that colour's photo to the front. */
  function initGallery(){
    const track=$('.gallery__track'); if(!track) return;
    const slides=$$('.gallery__slide',track), counter=$('.gallery__counter');
    const isDesk=()=>window.matchMedia('(min-width:768px)').matches;
    const setCount=i=>{ if(counter) counter.textContent=(i+1)+' / '+slides.length; };
    let raf; track.addEventListener('scroll',()=>{ if(isDesk()) return; cancelAnimationFrame(raf);
      raf=requestAnimationFrame(()=>setCount(Math.min(Math.round(track.scrollLeft/track.clientWidth),slides.length-1))); },{passive:true});
    galleryGoTo=(mediaId)=>{ if(!mediaId) return;
      const i=slides.findIndex(s=>s.dataset.mediaId===String(mediaId)); if(i<0) return;
      slides.forEach((s,si)=>s.classList.toggle('is-lead', si===i && i>0));
      if(isDesk()) return;
      /* scroll-snap-type:x mandatory cancels programmatic smooth scroll — jump instantly */
      track.scrollTo({left: slides[i].offsetLeft - slides[0].offsetLeft, behavior:'auto'});
      setCount(i); };
    $$('video',track).forEach(v=>{ v.muted=true; v.playsInline=true; v.setAttribute('playsinline',''); v.preload='none'; });
    setCount(0);
  }

  /* ============ 3.5 FULL-SCREEN ZOOM ============
     Tap (or Enter on) any gallery image: a full-screen viewer opens on that image. Swipe between
     images, tap to zoom 2x around the tap point, close with ×, Escape or the browser back gesture-free. */
  function initImageZoom(){
    const track=$('.gallery__track'); if(!track) return;
    let urls=[]; try{ urls=JSON.parse($('#cpdp-zoom-images')?.textContent||'[]'); }catch(e){}
    const imgSlides=$$('.gallery__slide',track).filter(s=>s.querySelector('img') && !s.querySelector('video,iframe'));
    if(!urls.length || !imgSlides.length) return;
    let view=null, opener=null;
    const load=i=>{ const im=view && $$('.zoomview__slide img',view)[i]; if(im && im.dataset.src){ im.src=im.dataset.src; im.removeAttribute('data-src'); } };
    function build(){
      view=document.createElement('div'); view.className='zoomview';
      view.setAttribute('role','dialog'); view.setAttribute('aria-modal','true'); view.setAttribute('aria-label','Product images, full screen');
      view.innerHTML='<button type="button" class="zoomview__close" aria-label="Close">&times;</button><div class="zoomview__count" aria-hidden="true"></div><div class="zoomview__track">'
        +urls.map((u,i)=>'<figure class="zoomview__slide"><img data-src="'+u+'" alt="Image '+(i+1)+' of '+urls.length+'"></figure>').join('')+'</div>';
      document.body.appendChild(view);
      const vt=$('.zoomview__track',view), cnt=$('.zoomview__count',view);
      let r; vt.addEventListener('scroll',()=>{ cancelAnimationFrame(r); r=requestAnimationFrame(()=>{ const i=Math.round(vt.scrollLeft/vt.clientWidth); cnt.textContent=(i+1)+' / '+urls.length; load(i); load(i+1); }); },{passive:true});
      $('.zoomview__close',view).addEventListener('click',close);
      vt.addEventListener('click',e=>{ const fig=e.target.closest('.zoomview__slide'); if(!fig) return;
        const on=!fig.classList.contains('is-zoomed'); fig.classList.toggle('is-zoomed',on);
        if(on){ const rc=fig.getBoundingClientRect(); const im=$('img',fig); if(im) im.style.transformOrigin=((e.clientX-rc.left)/rc.width*100)+'% '+((e.clientY-rc.top)/rc.height*100)+'%'; } });
    }
    function open(i){
      if(!view) build(); opener=document.activeElement;
      view.classList.add('is-open'); document.body.style.overflow='hidden';
      const vt=$('.zoomview__track',view); load(i); load(i+1);
      vt.scrollLeft=i*vt.clientWidth; $('.zoomview__count',view).textContent=(i+1)+' / '+urls.length;
      setTimeout(()=>$('.zoomview__close',view)?.focus(),50);
    }
    function close(){ if(!view||!view.classList.contains('is-open')) return; view.classList.remove('is-open'); document.body.style.overflow='';
      $$('.zoomview__slide.is-zoomed',view).forEach(f=>f.classList.remove('is-zoomed')); opener?.focus?.(); }
    window.__zoomClose=close;
    imgSlides.forEach((s,i)=>{
      s.setAttribute('role','button'); s.setAttribute('tabindex','0'); s.setAttribute('aria-label','Open image '+(i+1)+' full screen');
      s.addEventListener('click',()=>open(i));
      s.addEventListener('keydown',e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); open(i); } });
    });
  }

  /* ============ 9/10. VARIANT SELECTORS (wired to real variant objects) ============ */
  const OPT_NAMES = (CFG.optionNames||[]);
  const COLOR_IDX = OPT_NAMES.findIndex(n=>/colou?r/i.test(n));
  const SIZE_IDX  = OPT_NAMES.findIndex(n=>/size/i.test(n));
  const optVal = (v,idx)=> idx>=0 ? (v.options ? v.options[idx] : v['option'+(idx+1)]) : null;

  function initSelectors(){
    const colorName=$('#cpdp-color-name');
    $$('.selector--color .swatch').forEach(b=>b.addEventListener('click',()=>{
      $$('.selector--color .swatch').forEach(x=>x.setAttribute('aria-pressed','false')); b.setAttribute('aria-pressed','true');
      variant.color=b.dataset.value||$('.swatch__name',b)?.textContent.trim();
      if(colorName) colorName.textContent=variant.color;
      { const si=$('#cpdp-sticky-img'); if(si && b.dataset.img) si.src=b.dataset.img; }
      onVariantChange(true);
      galleryGoTo(b.dataset.mediaId);
    }));
    /* sold-out sizes stay selectable: the button then says "Sold out" instead of failing silently */
    $$('.size-pill').forEach(b=>b.addEventListener('click',()=>{
      $$('.size-pill').forEach(x=>x.setAttribute('aria-pressed','false')); b.setAttribute('aria-pressed','true');
      variant.size=b.dataset.value||b.textContent.trim(); hideSizeError(); setSizeLabel(); onVariantChange(true);
    }));
    /* starting state comes from the markup: first colour, no size — or the ?variant= deep link */
    const pre=$('.selector--color .swatch[aria-pressed="true"]');
    if(pre) variant.color=pre.dataset.value||$('.swatch__name',pre)?.textContent.trim();
    const preSize=$('.size-pill[aria-pressed="true"]');
    if(preSize) variant.size=preSize.dataset.value;
    setSizeLabel();
    if(CFG.deepLinked && pre) galleryGoTo(pre.dataset.mediaId);
    updateVariantUI();
  }
  function matchingVariants(){
    if(!SHOPIFY) return [];
    return CFG.variants.filter(v=>{
      if(COLOR_IDX>=0 && variant.color && optVal(v,COLOR_IDX)!==variant.color) return false;
      if(SIZE_IDX>=0  && variant.size  && optVal(v,SIZE_IDX)!==variant.size)  return false;
      return true;
    });
  }
  function currentVariant(){ const m=matchingVariants(); return m.find(v=>v.available) || m[0] || null; }
  function currentVariantId(){ return currentVariant()?.id || null; }
  function isFullySelected(){ return (COLOR_IDX<0 || variant.color) && (SIZE_IDX<0 || variant.size || !$$('.size-pill').length); }
  function setAtcLabel(btn,label){ const l=btn&&$('.atc__label',btn); if(l) l.textContent=label; else if(btn&&btn.childNodes[0]) btn.childNodes[0].nodeValue=label; }
  function setSizeLabel(){ const w=$('#cpdp-size-label'), n=$('#cpdp-size-name'); if(!w||!n) return; n.textContent=variant.size||''; w.hidden=!variant.size; }

  function onVariantChange(fromUser){ updateVariantUI(fromUser); if(fromUser && window.__lookSync) window.__lookSync(); }
  function updateVariantUI(fromUser){
    const el=$('.sticky-atc__variant .v'); if(el) el.textContent=variantLabel();
    if(!SHOPIFY) return;
    const v=currentVariant();
    // price + compare-at + saving + instalment + sticky price
    const pe=$('#cpdp-price'), ce=$('#cpdp-compare'), se=$('#cpdp-save');
    if(v && pe){ pe.textContent=money(v.price);
      const onSale=v.compareAt && v.compareAt>v.price;
      pe.classList.toggle('is-sale',!!onSale);
      if(ce){ if(onSale){ ce.textContent=money(v.compareAt); ce.hidden=false; } else { ce.hidden=true; } }
      if(se){ if(onSale){ se.textContent='Save '+Math.round((v.compareAt-v.price)*100/v.compareAt)+'%'; se.hidden=false; } else { se.hidden=true; } }
      const ap=$('#cpdp-afterpay-amt'); if(ap){ ap.textContent=money(Math.round(v.price/4)); const l=ap.closest('[data-ap-line]'); if(l) l.hidden=!(v.price>=+l.dataset.min&&v.price<=+l.dataset.max); }
      const sp=$('#cpdp-sticky-price'); if(sp) sp.textContent=money(v.price); }
    // shareable URL once the shopper has picked a full variant (never rewritten on load)
    if(fromUser && v && isFullySelected()){
      try{ const u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(history.state,'',u.toString()); }catch(e){}
    }
    // per-colour size availability
    if(SIZE_IDX>=0){
      $$('.size-pill').forEach(pill=>{
        const combo=CFG.variants.find(x=> (COLOR_IDX<0 || !variant.color || optVal(x,COLOR_IDX)===variant.color) && optVal(x,SIZE_IDX)===pill.dataset.value);
        const avail = combo ? combo.available : false;
        pill.classList.toggle('is-soldout',!avail);
        if(avail) pill.removeAttribute('aria-label'); else pill.setAttribute('aria-label',pill.dataset.value+', sold out');
      });
    }
    // ATC state
    const atc=$('#primary-atc');
    if(atc){
      if(isFullySelected() && (!v || !v.available)){ atc.disabled=true; setAtcLabel(atc,'Sold out'); }
      else { atc.disabled=false; setAtcLabel(atc, CFG.atcLabel || 'Add to bag'); }
    }
  }

  /* ============ 13/14/19. ACCORDIONS (height-animated) ============ */
  function initAccordions(){
    $$('.acc').forEach(acc=>{
      const head=$('.acc__head',acc), panel=$('.acc__panel',acc), inner=$('.acc__inner',acc);
      if(!head||!panel||!inner) return;
      if(acc.hasAttribute('open')) panel.style.height='auto';
      head.addEventListener('click',(e)=>{
        e.preventDefault();
        if(acc.hasAttribute('open')){
          panel.style.height=inner.offsetHeight+'px'; requestAnimationFrame(()=>panel.style.height='0px'); acc.removeAttribute('open');
        }else{
          acc.setAttribute('open',''); panel.style.height='0px';
          requestAnimationFrame(()=>panel.style.height=inner.offsetHeight+'px');
          panel.addEventListener('transitionend',function te(){ panel.style.height='auto'; panel.removeEventListener('transitionend',te); });
        }
      });
    });
  }

  /* ============ qty steppers + carousels ============ */
  function bindQty(scope=document){
    $$('.qty',scope).forEach(q=>{ if(q.__b) return; q.__b=1; const i=$('input',q);
      $('[data-step="-1"]',q)?.addEventListener('click',()=>{ i.value=Math.max(1,(+i.value||1)-1); i.dispatchEvent(new Event('change',{bubbles:true})); });
      $('[data-step="1"]',q)?.addEventListener('click',()=>{ i.value=(+i.value||1)+1; i.dispatchEvent(new Event('change',{bubbles:true})); });
    });
  }
  function initCarousels(scope=document){
    $$('[data-carousel]',scope).forEach(c=>{ if(c.__c) return; c.__c=1;
      const track=$('[data-carousel-track]',c)||$('.ugc__track,.yml__track',c);
      if(!track) return;
      $('.carousel-arrow--prev',c)?.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*0.7,behavior:'smooth'}));
      $('.carousel-arrow--next',c)?.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*0.7,behavior:'smooth'}));
      // "As seen on" opens centered on the middle clip (desktop only) so the wide
      // page gutter isn't left as blank space to the left of the first video.
      if(track.classList.contains('ugc__track')){
        const centerMid=()=>{
          if(!window.matchMedia('(min-width:768px)').matches) return;   // mobile has no meaningful left gap — leave it
          const cards=track.children; if(cards.length<3) return;
          const mid=cards[Math.floor(cards.length/2)];
          track.scrollLeft=Math.max(0, mid.offsetLeft-(track.clientWidth-mid.offsetWidth)/2);
        };
        centerMid();
        window.addEventListener('load',centerMid,{once:true});         // re-center once media reflows card widths
      }
    });
  }

  /* ============ UGC videos ("As Seen On") — click to play ============ */
  function initUgcVideos(){
    /* lazy posters: attach them only when the row is within ~1 screen */
    const lazy=$$('.ugc__video[data-poster]');
    const setPoster=v=>{ if(v.dataset.poster){ v.poster=v.dataset.poster; v.removeAttribute('data-poster'); } };
    if(lazy.length){
      if('IntersectionObserver' in window){
        const io=new IntersectionObserver(es=>es.forEach(en=>{ if(en.isIntersecting){ io.unobserve(en.target); setPoster(en.target); } }),{rootMargin:'800px 400px'});
        lazy.forEach(v=>io.observe(v));
      } else lazy.forEach(setPoster);
    }
    $$('.ugc__card').forEach(card=>{
      const video=$('.ugc__video',card), play=$('.ugc__play',card); if(!video) return;
      const start=()=>{
        $$('.ugc__video').forEach(v=>{ if(v!==video){ v.pause(); v.closest('.ugc__card')?.classList.remove('is-playing'); } });
        video.muted=true; const p=video.play(); if(p&&p.catch) p.catch(()=>{ video.muted=true; video.play(); });   // keep UGC clips silent
      };
      play?.addEventListener('click',e=>{ e.preventDefault(); e.stopPropagation(); start(); });
      video.addEventListener('click',()=>{ if(video.paused) start(); else video.pause(); });
      video.addEventListener('play',()=>card.classList.add('is-playing'));
      video.addEventListener('pause',()=>card.classList.remove('is-playing'));
      video.addEventListener('ended',()=>card.classList.remove('is-playing'));
    });
  }

  /* ============ HERO slideshow (homepage) ============ */
  function initHero(){
    const track=$('.hero-home__track'); if(!track) return;
    const slides=$$('.hero-home__slide',track), dots=$$('.hero-home__dots button');
    const setA=i=>dots.forEach((d,di)=>d.setAttribute('aria-current',di===i?'true':'false'));
    // scroll the TRACK horizontally only — never scrollIntoView (which would jump the whole page up)
    const goTo=i=>track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});
    dots.forEach((d,i)=>d.addEventListener('click',()=>{ goTo(i); setA(i); }));
    let raf; track.addEventListener('scroll',()=>{ cancelAnimationFrame(raf);
      raf=requestAnimationFrame(()=>setA(Math.min(Math.round(track.scrollLeft/track.clientWidth),slides.length-1))); });
    setA(0);
    const host=$('.hero-home');
    /* desktop shows both slides side by side, so no autoplay there */
    if(host && host.dataset.autoplay==='true' && slides.length>1 && !window.matchMedia('(min-width:1024px)').matches){
      const speed=(parseFloat(host.dataset.speed)||7)*1000; let idx=0, timer=null;
      const go=()=>{ idx=(idx+1)%slides.length; goTo(idx); setA(idx); };
      const start=()=>{ timer=setInterval(go,speed); }, stop=()=>clearInterval(timer);
      start(); track.addEventListener('pointerdown',stop); track.addEventListener('pointerup',start);
    }
  }

  /* ============ CART PAGE (full-page): qty + remove via AJAX ============ */
  function initCartPage(){
    const page=$('.cartpage'); if(!page) return;
    async function change(key,qty){
      try{
        const cart=await (await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})).json();
        if(qty===0 || !cart.item_count){ location.reload(); return; }
        // update this line's price + the subtotal without a full reload
        const line=cart.items.find(i=>i.key===key);
        const row=$(`.cartpage .li[data-key="${key}"]`);
        if(line && row){ const now=$('.li__price .now',row); if(now) now.textContent=money(line.final_line_price); }
        const sub=$('.cartpage__subtotal span:last-child'); if(sub) sub.textContent=money(cart.total_price);
        const co=$('.cartpage .checkout'); if(co) co.textContent='Checkout · '+money(cart.total_price);
      }catch(e){ location.reload(); }
    }
    $$('.cartpage .qty',page).forEach(q=>{
      const key=q.dataset.key, input=$('input',q); if(!key||!input) return;
      input.addEventListener('change',()=>change(key, Math.max(0,+input.value||0)));
    });
    // remove links → AJAX (avoids full navigation)
    $$('.cartpage .li__remove',page).forEach(a=>a.addEventListener('click',e=>{ e.preventDefault(); change(a.closest('.li').dataset.key, 0); }));
  }

  /* ============ MOBILE NAV DRAWER (homepage/global header) ============ */
  function initNavDrawer(){
    const toggle=$('.nav-toggle'), nav=$('.nav-drawer'); if(!toggle||!nav) return;
    const open=()=>{ overlay()?.classList.add('is-open'); nav.classList.add('is-open'); document.body.style.overflow='hidden'; };
    const close=()=>{ overlay()?.classList.remove('is-open'); nav.classList.remove('is-open'); document.body.style.overflow=''; };
    toggle.addEventListener('click',open);
    $('.nav-drawer__close',nav)?.addEventListener('click',close);
    nav.__close=close;
  }
  function closeAllOverlays(){
    closeDrawer();
    $('.nav-drawer')?.classList.remove('is-open');
    $('.filter-drawer')?.classList.remove('is-open');
    const m=$('.nl-modal'); if(m&&m.classList.contains('is-open')&&m.__close){ m.__close(); }
    const so=$('.search-overlay'); if(so&&so.classList.contains('is-open')&&so.__close){ so.__close(); }
    $('.sg-modal')?.classList.remove('is-open');
    $('.qa-sheet')?.classList.remove('is-open');
    document.body.style.overflow=''; overlay()?.classList.remove('is-open');
  }
  /* ---- size guide modal ---- */
  function initSizeGuide(){
    const modal=$('.sg-modal'); if(!modal) return;
    let opener=null;
    const open=(e)=>{ opener=e&&e.currentTarget; modal.classList.add('is-open'); overlay()?.classList.add('is-open'); document.body.style.overflow='hidden'; setTimeout(()=>$('.sg-modal__close',modal)?.focus(),60); };
    const close=()=>{ if(!modal.classList.contains('is-open')) return; modal.classList.remove('is-open'); overlay()?.classList.remove('is-open'); document.body.style.overflow=''; opener?.focus?.(); };
    $$('.sizeguide__open').forEach(b=>b.addEventListener('click',e=>{ e.preventDefault(); open(e); }));
    $('.sg-modal__close',modal)?.addEventListener('click',close);
    modal.__close=close;
    /* cm / in toggle — every measurement cell carries its cm value */
    $$('.sg__unit',modal).forEach(b=>b.addEventListener('click',()=>{
      const unit=b.dataset.unit;
      $$('.sg__unit',modal).forEach(x=>x.setAttribute('aria-pressed', x===b?'true':'false'));
      $$('td[data-cm]',modal).forEach(td=>{ const cm=+td.dataset.cm; td.textContent = unit==='in' ? (Math.round(cm/2.54*2)/2).toString() : cm.toString(); });
    }));
  }

  /* ============ GROUP 1 — PLP / search ============ */
  function initFilterDrawer(){
    const btn=$('.plp__filter-btn'), fd=$('.filter-drawer'); if(!btn||!fd) return;
    const open=()=>{ overlay()?.classList.add('is-open'); fd.classList.add('is-open'); document.body.style.overflow='hidden'; };
    const close=()=>{ overlay()?.classList.remove('is-open'); fd.classList.remove('is-open'); document.body.style.overflow=''; };
    btn.addEventListener('click',open);
    $('.filter-drawer__close',fd)?.addEventListener('click',close);
    $('.btn-apply',fd)?.addEventListener('click',close);
    // facet accordions
    $$('.facet__head',fd).forEach(h=>{const panel=h.nextElementSibling; if(!panel) return;
      h.addEventListener('click',()=>{ const open=h.getAttribute('aria-expanded')!=='false'; h.setAttribute('aria-expanded', open?'false':'true'); if(panel.classList) panel.style.display = open?'none':''; });
    });
    // seg / swatch selection is now handled by native <input> elements + :has() CSS
  }
  function initDensityToggle(){
    const grid=$('.plp__grid'); if(!grid) return;
    $$('.plp__density--m button').forEach(b=>b.addEventListener('click',()=>{
      $$('.plp__density--m button').forEach(x=>x.setAttribute('aria-pressed','false')); b.setAttribute('aria-pressed','true');
      grid.setAttribute('data-density', b.dataset.density||'2');
    }));
  }
  function initProductCards(scope=document){
    $$('.pcard__carousel',scope).forEach(c=>{ if(c.__pc) return; c.__pc=1;
      const track=$('.pcard__track',c), dots=$$('.pcard__dots button',c), slides=$$('.pcard__track > *',c);
      if(dots.length){
        const setA=i=>dots.forEach((d,di)=>d.setAttribute('aria-current',di===i?'true':'false'));
        let raf; track.addEventListener('scroll',()=>{ cancelAnimationFrame(raf); raf=requestAnimationFrame(()=>setA(Math.min(Math.round(track.scrollLeft/track.clientWidth),slides.length-1))); });
        dots.forEach((d,i)=>d.addEventListener('click',e=>{ e.preventDefault(); slides[i]?.scrollIntoView({behavior:'smooth',inline:'start',block:'nearest'}); setA(i); }));
      }
    });
  }
  /* ---- "You may also like" (PDP): per-card size/colour selects + real add-to-cart ---- */
  function initUpsellCards(scope=document){
    $$('.pcard--upsell',scope).forEach(card=>{
      if(card.__upsell) return; card.__upsell=1;
      let variants=[]; try{ variants=JSON.parse($('.pcard__variants',card)?.textContent||'[]'); }catch(e){}
      const selects=$$('.pcard__select',card);
      const priceNow=$('.pcard__price .now',card), priceWas=$('.pcard__price .was',card);
      const img=$('.pcard__img',card), addBtn=$('.pcard__add',card);

      function currentVariant(){
        const chosen=selects.map(s=>s.value);
        return variants.find(v=>chosen.every((val,i)=>(v['option'+(i+1)]||null)===val)) || null;
      }
      function sync(){
        const v=currentVariant();
        if(!v){ if(addBtn){ addBtn.disabled=true; addBtn.textContent='Unavailable'; } return; }
        if(addBtn){
          addBtn.dataset.vid=v.id;
          addBtn.disabled=!v.available;
          addBtn.textContent=v.available?(card.dataset.cta||'Add to Cart'):'Sold Out';
        }
        if(priceNow) priceNow.textContent=money(v.price);
        if(priceWas){
          if(v.compare_at_price>v.price){ priceWas.textContent=money(v.compare_at_price); priceWas.style.display=''; }
          else priceWas.style.display='none';
        }
        if(img && v.image) img.src=v.image;
      }
      selects.forEach(s=>s.addEventListener('change',sync));
      sync();

      addBtn?.addEventListener('click',async()=>{
        const v=currentVariant();
        if(!v || !v.available) return;
        addBtn.classList.add('is-loading');
        if(SHOPIFY){
          try{
            const r=await addLine(v.id,1);
            await maybeAddGift();
            await renderShopifyCart(CFG.giftVariantId?null:r); openDrawer();
          }catch(e){
            console.error('[cpdp] upsell add failed',e);
            closeDrawer();
            let note=$('.pcard__error',card);
            if(!note){ note=document.createElement('p'); note.className='pcard__error'; note.setAttribute('role','alert'); addBtn.insertAdjacentElement('afterend',note); }
            note.textContent=friendlyError(e);
          }
        } else {
          upsert({id:v.id,name:card.dataset.name||'[PRODUCT TITLE]',opt:selects.map(s=>s.value).join(' / '),price:v.price/100,compareAt:v.compare_at_price/100,qty:1});
          applyGiftDemo();
          setTimeout(renderDemoCart,400);
        }
        addBtn.classList.remove('is-loading');
      });
    });
  }
  /* Swap the upsell grid for Shopify's RELATED products (intent=related) via the
     Section Rendering API, so "We think you'll love" reflects the product being
     viewed instead of a fixed collection. Falls back silently to the server-rendered
     grid if the request fails or returns nothing. */
  function initUpsellRecs(){
    dedupeUpsell();
    const sec=$('.upsell[data-recs-url]'); if(!sec) return;
    const url=sec.getAttribute('data-recs-url'); if(!url) return;
    /* fetched as the shopper approaches the row, not during page load */
    if('IntersectionObserver' in window){ const io=new IntersectionObserver(es=>{ if(es.some(e=>e.isIntersecting)){ io.disconnect(); loadRecs(sec,url); } },{rootMargin:'800px 0px'}); io.observe(sec.closest('.shopify-section')||sec); return; }
    loadRecs(sec,url);
  }
  /* "You may also like" never repeats the dresses in "Complete the look"; runs when either row lands */
  function dedupeUpsell(){
    const sec=$('.upsell'), grid=sec&&$('.pgrid',sec); if(!grid) return;
    const skip=new Set(window.__lookPicks||[]), want=+sec.dataset.count||99; let kept=0;
    $$('.pcard',grid).forEach(c=>{ const show=!skip.has(c.getAttribute('data-handle'))&&kept<want; c.classList.toggle('is-spare',!show); if(show) kept++; });
    grid.setAttribute('data-deduped','');
  }
  window.__dedupeUpsell=dedupeUpsell;
  function loadRecs(sec,url){
    fetch(url).then(r=>r.ok?r.text():Promise.reject(r.status)).then(html=>{
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.querySelector('.upsell .pgrid')||doc.querySelector('.pgrid');
      const grid=$('.pgrid',sec);
      if(fresh && grid && fresh.querySelector('.pcard')){
        grid.innerHTML=fresh.innerHTML;   // real related products
        dedupeUpsell();
        grid.scrollLeft=0;
        initUpsellCards(sec);             // wire the new cards (guarded per-card)
      }
    }).catch(()=>{});
  }
  function initPriceRange(){
    $$('.price-range').forEach(pr=>{
      if(pr.__b) return; pr.__b=1;
      const min=$('input[data-role="min"]',pr), max=$('input[data-role="max"]',pr), fill=$('.price-range__fill',pr);
      const boxMin=document.querySelector(pr.dataset.minInput||'#price-min'), boxMax=document.querySelector(pr.dataset.maxInput||'#price-max');
      if(!min||!max) return;
      const lo=+min.min, hi=+min.max, span=hi-lo || 1;
      const paint=(write)=>{ let a=+min.value, b=+max.value; if(a>b){ [a,b]=[b,a]; } if(fill){ fill.style.left=((a-lo)/span*100)+'%'; fill.style.width=((b-a)/span*100)+'%'; } if(write){ if(boxMin) boxMin.value=a; if(boxMax) boxMax.value=b; } };
      min.addEventListener('input',()=>paint(true)); max.addEventListener('input',()=>paint(true));
      if(boxMin) boxMin.addEventListener('change',()=>{ min.value=boxMin.value; paint(); });
      if(boxMax) boxMax.addEventListener('change',()=>{ max.value=boxMax.value; paint(); });
      paint(false);
    });
  }

  /* ============ STICKY ATC BAR ============ */
  function initStickyBar(){
    const atc=$('#primary-atc'), bar=$('.sticky-atc'); if(!atc||!bar) return;
    onVariantChange();
    const update=()=>{ const on=atc.getBoundingClientRect().bottom<0; bar.classList.toggle('is-visible', on); bar.setAttribute('aria-hidden', on?'false':'true'); const b=$('.sticky-atc__btn',bar); if(b) b.tabIndex=on?0:-1; };
    if('IntersectionObserver' in window){ new IntersectionObserver(update,{threshold:0}).observe(atc); }
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
    $('.sticky-atc__btn',bar)?.addEventListener('click',()=>atc.click());
    const sbtn=$('.sticky-atc__btn',bar);
    new MutationObserver(()=>{ if(sbtn){ sbtn.disabled=atc.disabled; sbtn.textContent=$('.atc__label',atc)?.textContent||sbtn.textContent; } }).observe(atc,{attributes:true,childList:true,subtree:true,characterData:true});
  }

  /* ============ HEADER reveal-on-scroll-up ============ */
  function initHeaderReveal(){
    const hdr=$('.hdr'); if(!hdr) return;
    const ann=$('.ann');
    // Driven off the announcement's LIVE on-screen position via rAF rather than scroll
    // events. getBoundingClientRect reflects the real visual position under ANY scroll
    // mechanism (native window scroll, an overflow wrapper, or a transform-based smooth
    // scroll), so this is bulletproof where the old window.scrollY maths silently froze
    // the header at top:54px — leaving a gap above it once the announcement scrolled away.
    let lastY=0, hidden=false, lastTop=-1, lastHidden=null, queued=false;
    /* Runs only when something scrolls (any scroller — captured at document level), on resize and
       on load, one rAF per burst. The old version re-measured every frame forever, forcing layout
       work on the main thread even when the page was idle. */
    const schedule=()=>{ if(queued) return; queued=true; requestAnimationFrame(()=>{ queued=false; tick(); }); };
    const tick=()=>{
      const rect = ann ? ann.getBoundingClientRect() : null;
      const annBottom = rect ? Math.round(rect.bottom) : 0;
      const top = Math.max(0, annBottom);                      // flush under the announcement; 0 once it's gone
      if(top!==lastTop){ hdr.style.top = top + 'px'; lastTop=top; }
      const y = rect ? Math.round(-rect.top) : (window.scrollY||0);   // monotonic scroll proxy (scroll-mechanism-agnostic)
      if(annBottom>0) hidden=false;                            // in the announcement zone: always show
      else if(y>lastY+4) hidden=true;                          // scrolling down: hide
      else if(y<lastY-4) hidden=false;                         // scrolling up: reveal
      if(Math.abs(y-lastY)>0.5) lastY=y;
      if(hidden!==lastHidden){ hdr.classList.toggle('hdr--hidden', hidden); lastHidden=hidden; }
      hdr.classList.toggle('hdr--compact', annBottom<=0);
    };
    document.addEventListener('scroll',schedule,{passive:true,capture:true});
    window.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('load',schedule,{once:true});
    /* the announcement can change height without any scroll (web fonts, the tier bar filling in) */
    if('ResizeObserver' in window){ const ro=new ResizeObserver(schedule); if(ann) ro.observe(ann); const aov=$('.aov:not(.aov--drawer)'); if(aov) ro.observe(aov); }
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(schedule).catch(()=>{});
    schedule();
  }

  /* ============ AOV nudge bar (progress to next Buy More / Save More tier) ============ */
  /* Multi-buy tiers: ONE source — Theme settings > Store facts, rendered as JSON on [data-tiers].
     They mirror the real automatic discount, which applies per group of the top tier's size, so
     past the top tier we never promise a bigger % on everything. */
  let _tiers=null;
  function getTiers(){
    if(_tiers) return _tiers;
    let t=[]; try{ t=JSON.parse(($('[data-tiers]')?.dataset.tiers)||'[]'); }catch(e){}
    _tiers=t.filter(x=>x.n>0&&x.pct>0).sort((a,b)=>a.n-b.n); return _tiers;
  }
  function initAovBar(){
    const bars=$$('.aov');
    const renderers=bars.map(bar=>{
      const tiers=getTiers();
      if(!tiers.length) return ()=>{};
      const textEl=$('.aov__text',bar), fill=$('.aov__fill',bar);
      return (count)=>{
        count=count||0;
        const next=tiers.find(t=>count<t.n);
        const unlocked=tiers.filter(t=>count>=t.n).pop();
        if(!next){
          const top=tiers[tiers.length-1];
          bar.classList.add('aov--max');
          textEl.innerHTML= count===top.n ? 'You’ve unlocked the max <strong>'+top.pct+'% off</strong>'
            : 'Top saving unlocked: <strong>'+top.pct+'% off</strong> every '+top.n+' pieces';
          fill.style.width='100%'; return;
        }
        bar.classList.remove('aov--max');
        const need=next.n-count;
        fill.style.width=Math.min(100,Math.round(count/next.n*100))+'%';
        if(unlocked) textEl.innerHTML=unlocked.pct+'% off unlocked. Add <strong>'+need+'</strong> more for <strong>'+next.pct+'% off</strong>';
        else textEl.innerHTML='Add <strong>'+need+'</strong> item'+(need>1?'s':'')+' to unlock <strong>'+next.pct+'% off</strong>';
      };
    });
    const renderAll=(count)=>{ lastPieces=count||0; renderers.forEach(r=>r(count)); renderVoldisc(lastPieces+addonExtra()); window.__lookBag&&window.__lookBag(count||0); };
    window.__aov=renderAll;
    if(window.Shopify) fetch('/cart.js').then(r=>r.json()).then(c=>renderAll(pieceCount(c))).catch(()=>renderAll(0));
    else renderAll((demo.items||[]).reduce((s,i)=>s+i.qty,0));
  }

  /* ---- multi-buy card: highlight the tier this item would reach, from what's already in the bag ---- */
  /* when the add-on counts as a piece and its box is ticked, the multi-buy card speaks for dress + add-on */
  let lastPieces=0;
  const addonExtra=()=>(addon.on && addon.el && addon.el.dataset.counts==='1') ? 1 : 0;
  function renderVoldisc(count){
    const box=$('.voldisc'); if(!box) return;
    const tiers=getTiers(), line=$('.voldisc__now',box); if(!tiers.length||!line) return;
    const withThis=count+1, top=tiers[tiers.length-1];
    const hit=tiers.filter(t=>withThis>=t.n).pop();
    if(withThis>top.n){ line.textContent=''; return; }
    if(hit) line.innerHTML='Add this to your bag and save <strong>'+hit.pct+'%</strong> on your order.';
    else { const need=tiers[0].n-withThis; line.innerHTML='Add this plus '+need+' more piece'+(need>1?'s':'')+' to save <strong>'+tiers[0].pct+'%</strong>'; }
  }
  /* effective multi-buy % for n pieces of similar price, applying tiers per group of the top tier */
  function effectivePct(n){
    const tiers=getTiers(); if(!tiers.length||n<=0) return 0;
    const top=tiers[tiers.length-1], pctFor=k=>{ const h=tiers.filter(t=>k>=t.n).pop(); return h?h.pct:0; };
    const full=Math.floor(n/top.n), rest=n%top.n;
    return (full*top.n*top.pct + rest*pctFor(rest))/n;
  }

  /* ============ 11/12. ADD TO CART ============ */
  /* /cart/add.js that throws a readable error on 4xx/5xx instead of failing silently */
  function cartFromSections(j){
    const html=j && j.sections && j.sections['cpdp-cart-json'];
    const m=html && html.match(/<script[^>]*>([\s\S]*?)<\/script>/);
    if(!m) return null; try{ return JSON.parse(m[1]); }catch(e){ return null; }
  }
  async function addItems(items){
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:bagSections(),sections_url:location.pathname})});
    if(!res.ok){
      let msg=''; try{ const j=await res.json(); msg=j.description||j.message||''; }catch(e){}
      const err=new Error(msg); err.status=res.status; throw err;
    }
    const j=await res.json(); j.__cart=cartFromSections(j); return j;
  }
  function addLine(id,qty){ return addItems([{id,quantity:qty||1}]); }
  function friendlyError(e){
    if(e && e.status===422) return (e.message && typeof e.message==='string') ? e.message : 'Sorry, that size has just sold out. Please choose another.';
    if(e && e.status===429) return 'Lots of people are shopping right now. Please try again in a moment.';
    if(!navigator.onLine || (e && e.name==='TypeError')) return 'We couldn’t reach your bag. Check your connection and try again.';
    return 'Something went wrong adding this to your bag. Please try again.';
  }
  function showAtcError(e){ const el=$('#cpdp-atc-error'); if(!el) return; el.textContent=friendlyError(e); el.hidden=false; }
  function hideAtcError(){ const el=$('#cpdp-atc-error'); if(el){ el.hidden=true; el.textContent=''; } }
  /* ---- add-on tick-box under Add to bag (the adhesive bra): ticking it adds both in one go ---- */
  const addon={ el:null, on:false, variant:null, reset:null };
  function hideAddonErr(){ const e=addon.el&&$('[data-addon-err]',addon.el); if(e) e.hidden=true; }
  function addonMsg(t){ const m=addon.el&&$('[data-addon-msg]',addon.el); if(m){ m.textContent=t||''; m.hidden=!t; } }
  function initAddon(){
    const el=$('[data-addon]'); if(!el||el.__b) return; el.__b=1; addon.el=el;
    const check=$('[data-addon-check]',el), opts=$('[data-addon-opts]',el), label=$('#primary-atc .atc__label');
    const base=label?label.textContent:'';
    addon.variant=el.dataset.variant||null;
    const sync=()=>{ addon.on=check.checked; el.classList.toggle('is-on',addon.on); if(opts) opts.hidden=!addon.on; if(label) label.textContent=addon.on?'Add both to bag':base; if(!addon.on) hideAddonErr(); addonMsg(''); renderVoldisc(lastPieces+addonExtra()); };
    check.addEventListener('change',sync);
    el.addEventListener('click',e=>{ const b=e.target.closest('[data-addon-variant]'); if(!b||b.disabled) return;
      $$('[data-addon-variant]',el).forEach(x=>x.setAttribute('aria-pressed',x===b?'true':'false')); addon.variant=b.dataset.addonVariant;
      const pr=$('[data-addon-price]',el); if(pr&&b.dataset.price) pr.textContent='+ '+b.dataset.price; hideAddonErr(); });
    addon.reset=()=>{ check.checked=false; sync(); };
    sync();
  }
  /* ticked but no size chosen for the add-on: ask, add nothing */
  function addonNeedsChoice(){
    if(!addon.el||!addon.on||addon.variant) return false;
    const e=$('[data-addon-err]',addon.el); if(e) e.hidden=false;
    addon.el.scrollIntoView({behavior:'smooth',block:'center'}); return true;
  }
  function addToCart(){
    if(CFG.requireSize!==false && !variant.size && $$('.size-pill').length){ flashSelectSize(); return; }
    if(addonNeedsChoice()) return;
    hideAtcError();
    const btn=$('#primary-atc'); btn?.classList.add('is-loading'); btn?.setAttribute('aria-busy','true');
    { const st=$('#cpdp-atc-status'); if(st) st.textContent='Adding…'; }
    if(SHOPIFY) return shopifyAdd(btn);
    openDrawer();
    // demo
    upsert({id:'main',name:CFG.title||'[PRODUCT TITLE]',opt:variantLabel(),price:demo.price,compareAt:demo.compareAt,qty:1});
    applyGiftDemo();
    setTimeout(()=>{ btn?.classList.remove('is-loading'); renderDemoCart(); showAddedToast(); },850);
  }
  /* green "Added to cart" banner inside the drawer — visible confirmation, no delay to the drawer */
  function showAddedToast(){
    const t=$('.drawer__added'); if(!t) return;
    t.classList.add('is-show'); clearTimeout(t.__h);
    t.__h=setTimeout(()=>t.classList.remove('is-show'), 2200);
  }
  function buyNow(){
    if(CFG.requireSize!==false && !variant.size && $$('.size-pill').length){ flashSelectSize(); return; }
    const btn=$('#buy-now');
    hideAtcError();
    if(SHOPIFY){
      const id=currentVariantId();
      if(!id){ flashSelectSize(); return; }
      const label=btn?btn.innerHTML:'';
      if(btn){ btn.disabled=true; btn.textContent='One moment…'; }
      addLine(id,1)
        .then(()=>maybeAddGift()).then(()=>{ window.location.href='/checkout'; })
        .catch(e=>{ console.error('[cpdp] buy now failed',e); showAtcError(e); if(btn){ btn.disabled=false; btn.innerHTML=label; } });
    } else { window.location.href='/checkout'; }
  }
  /* No size chosen: one validation path for the main button, Buy Now and the sticky bar —
     an inline message under the sizes, scrolled into view, and nothing is added. */
  function flashSelectSize(){
    const box=$('.selector--size'), err=$('#cpdp-size-error'), s=$('.sizes');
    if(err) err.hidden=false;
    box?.classList.add('has-error');
    box?.scrollIntoView({behavior:'smooth',block:'center'});
    s?.animate([{transform:'translateX(0)'},{transform:'translateX(-4px)'},{transform:'translateX(4px)'},{transform:'translateX(0)'}],{duration:250,delay:250});
  }
  function hideSizeError(){
    const err=$('#cpdp-size-error'); if(err) err.hidden=true;
    $('.selector--size')?.classList.remove('has-error');
  }

  /* ---- demo cart helpers ---- */
  function upsert(item){ const e=demo.items.find(i=>i.id===item.id&&i.opt===item.opt); if(e) e.qty+=item.qty; else demo.items.push({...item}); }
  function applyGiftDemo(){
    const sub=demo.items.filter(i=>i.id!=='gift').reduce((s,i)=>s+i.price*i.qty,0);
    const has=demo.items.some(i=>i.id==='gift');
    if(sub>=demo.giftThreshold&&!has) demo.items.unshift({id:'gift',name:CFG.giftName||'[GIFT ITEM]',opt:'Colour: Gold',price:0,compareAt:demo.giftValue,qty:1,gift:true});
    else if(sub<demo.giftThreshold&&has) demo.items=demo.items.filter(i=>i.id!=='gift');
  }

  /* ---- shopify cart ---- */
  async function shopifyAdd(btn){
    try{
      const id=currentVariantId();
      if(!id){ btn?.classList.remove('is-loading'); closeDrawer(); flashSelectSize(); return; }
      let r;
      if(addon.on && addon.variant){
        /* both in one request; if the add-on can't be added, the dress still goes in */
        try{ r=await addItems([{id,quantity:1},{id:+addon.variant,quantity:1}]); addon.reset&&addon.reset(); }
        catch(e2){ r=await addLine(id,1); addon.reset&&addon.reset(); addonMsg('We couldn’t add that just now. Your dress is in the bag.'); }
      } else r=await addLine(id,1);
      await maybeAddGift();
      await renderShopifyCart(CFG.giftVariantId ? null : r);
      openDrawer(btn);
      { const st=$('#cpdp-atc-status'); if(st) st.textContent='Added to your bag'; }
    }catch(e){
      console.error('[cpdp] add failed',e);
      closeDrawer();
      showAtcError(e);
      { const st=$('#cpdp-atc-status'); if(st) st.textContent=''; }
      const err=$('#cpdp-atc-error'); if(err && err.getBoundingClientRect().bottom>innerHeight) err.scrollIntoView({behavior:'smooth',block:'center'});
    }
    finally{ btn?.classList.remove('is-loading'); btn?.removeAttribute('aria-busy'); }
  }
  async function maybeAddGift(){
    if(!CFG.giftVariantId) return;
    const cart=await (await fetch('/cart.js')).json();
    const hasGift=cart.items.some(i=>i.variant_id===CFG.giftVariantId);
    const eligible=cart.total_price >= (CFG.giftThreshold*100);
    if(eligible && !hasGift) await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:CFG.giftVariantId,quantity:1}]})});
    if(!eligible && hasGift){ const line=cart.items.find(i=>i.variant_id===CFG.giftVariantId);
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})}); }
  }
  /* ============ THE BAG (side cart + /cart page) ============
     The drawer is pre-rendered with the page (sections/cpdp-cart-drawer), so opening it is pure CSS.
     Adds and quantity changes ask Shopify for the fresh drawer (and /cart page) HTML in the SAME
     request (sections=…), swap it in, then animate the progress fill and the saving from their
     previous values. */
  const BAG_ID='cpdp-cart-drawer';
  const rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  const reduceMotion=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const getJSON=u=>fetch(u,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():Promise.reject(r.status));
  const isMens=t=>/\bmen'?s?\b|\bmens\b|men\u2019s/i.test(t||'') && !/women/i.test(t||'');
  /* pieces that count toward the multi-buy: the add-on (adhesive bra) doesn't, unless Store facts says so */
  const addonSkip=()=>(($('.bag-root')||{dataset:{}}).dataset.addonSkip||'').split(',').map(x=>x.trim()).filter(Boolean);
  const pieceCount=cart=>{ if(!cart||!cart.items) return 0; const skip=addonSkip(); return cart.items.reduce((n,i)=>n+(skip.includes(i.handle)?0:i.quantity),0); };
  function bagSections(){ const ids=[BAG_ID,'cpdp-cart-json']; const pg=$('[data-bag-page]'); if(pg&&pg.dataset.section) ids.push(pg.dataset.section); return ids; }
  function cartJsonFrom(sections){ const html=sections&&sections['cpdp-cart-json']; const m=html&&html.match(/<script[^>]*>([\s\S]*?)<\/script>/); if(!m) return null; try{ return JSON.parse(m[1]); }catch(e){ return null; } }
  function animateFill(fill,from){
    if(!fill) return; const to=(fill.dataset.fill||'0')+'%';
    if(reduceMotion()){ fill.style.width=to; return; }
    fill.style.transition='none'; fill.style.width=from||'0%'; void fill.offsetWidth;
    fill.style.transition=''; requestAnimationFrame(()=>{ fill.style.width=to; });
  }
  function countUp(el,from){
    if(!el) return; const to=+el.dataset.cents||0;
    if(reduceMotion()||from===to){ el.textContent=money(to); return; }
    const t0=performance.now(), d=600;
    const step=t=>{ const k=Math.min(1,(t-t0)/d), e=1-Math.pow(1-k,3); el.textContent=money(Math.round(from+(to-from)*e)); if(k<1) requestAnimationFrame(step); };
    el.textContent=money(from); requestAnimationFrame(step);
  }
  let bagSeen=false, lastSaving=0, lastFill='0%';
  /* run the "entrance" motion: from the previous values (or from zero the first time it opens) */
  function bagMotion(scope,prevFill,prevSaving){
    animateFill($('.bag__fill',scope),prevFill);
    const amt=$('[data-saving-amt]',scope), now=amt?+amt.dataset.cents:0;
    if(amt) countUp(amt,prevSaving);
    if(amt && now>prevSaving && prevSaving>0 && !reduceMotion()){ const row=$('[data-bag-saving]',scope); row?.classList.remove('is-pulse'); void row?.offsetWidth; row?.classList.add('is-pulse'); }
  }
  function swapBag(sections){
    if(!sections) return null;
    const cart=cartJsonFrom(sections);
    const html=sections[BAG_ID], host=document.getElementById('shopify-section-'+BAG_ID);
    if(html && host){
      const old=$('.bag-root',host), oldScroll=$('[data-bag-scroll]',host)?.scrollTop||0;
      const prevFill=$('.bag__fill',host)?.style.width||'0%', prevSaving=+($('[data-saving-amt]',host)?.dataset.cents||0);
      const fresh=new DOMParser().parseFromString(html,'text/html').querySelector('.bag-root');
      if(old && fresh){ old.replaceWith(fresh); const sc=$('[data-bag-scroll]',fresh); if(sc) sc.scrollTop=oldScroll;
        if(drawer()?.classList.contains('is-open')) bagMotion(fresh,prevFill,prevSaving); else bagSeen=false; }
    }
    const pg=$('[data-bag-page]');
    if(pg && sections[pg.dataset.section]){
      const prevFill=$('.bag__fill',pg)?.style.width||'0%', prevSaving=+($('[data-saving-amt]',pg)?.dataset.cents||0);
      const fresh=new DOMParser().parseFromString(sections[pg.dataset.section],'text/html').querySelector('[data-bag]');
      const old=$('[data-bag]',pg); if(old && fresh){ old.replaceWith(fresh); bagMotion(fresh,prevFill,prevSaving); }
    }
    return cart;
  }
  function afterBag(cart){
    const bag=$('#shopify-section-'+BAG_ID+' [data-bag]')||$('[data-bag]');
    const count=cart ? cart.item_count : +(bag?.dataset.count||0);
    $$('.cart-count').forEach(c=>c.textContent=count);
    window.__aov && window.__aov(cart ? pieceCount(cart) : +(bag?.dataset.pieces||count));
    fillAddons(cart);
  }
  /* Safety nets for a section Shopify didn't render (null): the pre-rendered empty bag when the cart
     is empty, otherwise re-read the drawer (and /cart page) from a fresh render of this page. */
  async function patchSections(sections,cartHint){
    sections=Object.assign({},sections||{});
    const host=document.getElementById('shopify-section-'+BAG_ID), pg=$('[data-bag-page]');
    const needDrawer=host && !sections[BAG_ID], needPage=pg && !sections[pg.dataset.section];
    if(!needDrawer && !needPage) return sections;
    const count=cartHint ? cartHint.item_count : (cartJsonFrom(sections)||{}).item_count;
    const tpl=host && host.querySelector('template[data-bag-empty-tpl]');
    if(needDrawer && count===0 && tpl) sections[BAG_ID]='<div>'+tpl.innerHTML+'</div>';
    if((needDrawer && !sections[BAG_ID]) || needPage){
      try{
        const doc=new DOMParser().parseFromString(await (await fetch(location.pathname+location.search,{headers:{Accept:'text/html'}})).text(),'text/html');
        if(needDrawer && !sections[BAG_ID]){ const r=doc.querySelector('#shopify-section-'+BAG_ID+' .bag-root'); if(r) sections[BAG_ID]='<div>'+r.outerHTML+'</div>'; }
        if(needPage){ const r=doc.querySelector('[data-bag-page] [data-bag]'); if(r) sections[pg.dataset.section]='<div>'+r.outerHTML+'</div>'; }
      }catch(e){ console.error('[cpdp] bag fallback',e); }
    }
    return sections;
  }
  async function refreshBag(sections,cartHint){
    if(!sections){ try{ sections=await getJSON(rootUrl+'?sections='+bagSections().join(',')); }catch(e){ sections={}; } }
    sections=await patchSections(sections,cartHint);
    const cart=swapBag(sections)||cartHint||null; afterBag(cart); return cart;
  }
  /* legacy name kept for callers: accepts an add/change response (with .sections) or nothing */
  function renderShopifyCart(resp){ return refreshBag(resp && resp.sections, resp && typeof resp.item_count==='number' ? resp : null); }

  /* quantity steppers + remove — delegated, because the bag HTML is swapped after every change */
  async function changeLine(key,qty,line){
    if(line){ if(line.classList.contains('is-busy')) return; line.classList.add('is-busy'); line.setAttribute('aria-busy','true'); }
    try{
      const res=await fetch(rootUrl+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:qty,sections:bagSections(),sections_url:location.pathname})});
      if(!res.ok){ let msg=''; try{ msg=(await res.json()).description||''; }catch(e){} const err=new Error(msg); err.status=res.status; throw err; }
      const changed=await res.json();
      await maybeAddGift();
      await refreshBag(CFG.giftVariantId?null:changed.sections, CFG.giftVariantId?null:changed);
    }catch(e){
      console.error('[cpdp] cart change failed',e);
      line?.classList.remove('is-busy'); line?.removeAttribute('aria-busy');
      const qn=line?.querySelector('.bag__n'); if(qn && qn.dataset.prev){ qn.textContent=qn.dataset.prev; delete qn.dataset.prev; }
      const box=line?.querySelector('.bag__info')||$('[data-bag]');
      if(box){ $('.drawer__error',box)?.remove(); const n=document.createElement('p'); n.className='drawer__error'; n.setAttribute('role','alert'); n.textContent=(e.status===422&&e.message)?e.message:'We couldn’t update your bag. Please try again.'; box.append(n); }
    }
  }
  function initBag(){
    document.addEventListener('click',e=>{
      const q=e.target.closest('[data-bag] [data-qty]');
      if(q){ e.preventDefault(); const line=q.closest('.bag__line'); if(!line||line.classList.contains('is-busy')) return;
        const next=Math.max(0,+q.dataset.qty||0), n=$('.bag__n',line);
        if(n && next>0){ n.dataset.prev=n.textContent; n.textContent=next; }   /* the new number shows on tap; the cart response confirms it */
        changeLine(line.dataset.key, next, line); return; }
      if(e.target.closest('[data-bag-close]')){ e.preventDefault(); closeDrawer(); return; }
      const co=e.target.closest('[data-checkout]');
      if(co){
        /* block a second real tap while checkout loads; let app-scripted re-clicks (not isTrusted) through */
        if(co.classList.contains('is-loading')){ if(e.isTrusted) e.preventDefault(); return; }
        co.classList.add('is-loading'); co.setAttribute('aria-busy','true');
        setTimeout(()=>{ co.classList.remove('is-loading'); co.removeAttribute('aria-busy'); },8000);
        return;
      }
      const add=e.target.closest('[data-addon-add]');
      if(add){ e.preventDefault(); addAddon(add); }
    });
    const pg=$('[data-bag-page]'); if(pg) bagMotion(pg,'0%',0);
    afterBag(null);
  }

  /* ---- "Complete the outfit" row: complementary picks for the newest item → chosen collection → women's
     layers by search; only pieces under the price cap and not already in the bag; hidden if empty ---- */
  const addonCache={};
  const priceCents=p=>{ const v=p.price; return typeof v==='string' ? Math.round(parseFloat(v)*100) : (v||0); };
  /* Dresses that go with a piece: Shopify's complementary then related picks for it, topped up from a dresses
     collection (starting at a different place per product so neighbours differ). Never the men's range. */
  const isDress=p=>/\bdress(es)?\b/i.test(String((p&&p.title)||'')+' '+String((p&&(p.type||p.product_type))||''));
  const dressCache={};
  async function dressCandidates(productId,fallback){
    const key=productId+'|'+(fallback||''); if(dressCache[key]) return dressCache[key];
    let c=[];
    for(const intent of ['complementary','related']){ try{ c=c.concat(((await getJSON(rootUrl+'recommendations/products.json?product_id='+productId+'&intent='+intent+'&limit=10')).products)||[]); }catch(e){} }
    c=c.filter(isDress);
    if(c.length<6 && fallback){ try{
      const f=((await getJSON(rootUrl+'collections/'+encodeURIComponent(fallback)+'/products.json?limit=30')).products||[]).map(p=>({id:p.id,handle:p.handle,title:p.title,type:p.product_type,price:p.variants&&p.variants[0]?p.variants[0].price:0,available:p.variants?p.variants.some(v=>v.available):true,featured_image:p.images&&p.images[0]?p.images[0].src:null})).filter(isDress);
      const k=f.length?(+productId||0)%f.length:0; c=c.concat(f.slice(k),f.slice(0,k)); }catch(e){} }
    const seen=new Set(); c=c.filter(p=>p&&p.available!==false&&!isMens(p.title)&&!seen.has(p.id)&&seen.add(p.id));
    return (dressCache[key]=c);
  }
  async function addonCandidates(newest,rootEl){
    if(addonCache[newest]) return addonCache[newest];
    let c=await dressCandidates(newest,rootEl?.dataset.addonCollection||'');
    const terms=(rootEl?.dataset.addonTerms||'').split(',').map(t=>t.trim()).filter(Boolean);
    if(!c.length) for(const t of terms){ try{ const d=await getJSON(rootUrl+'search/suggest.json?q='+encodeURIComponent(t)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide'); c=c.concat(((d.resources&&d.resources.results&&d.resources.results.products)||[]).filter(p=>isDress(p)&&!isMens(p.title))); }catch(e){} }
    addonCache[newest]=c; return c;
  }

  async function fillAddons(cart){
    const box=$('[data-bag-addons]'); if(!box) return;
    const rootEl=$('.bag-root'); 
    if(!cart){ try{ cart=await getJSON(rootUrl+'cart.js'); }catch(e){ return; } }
    if(!cart.items||!cart.items.length){ box.hidden=true; return; }
    const inBag=new Set(cart.items.map(i=>i.product_id)), cap=+(rootEl?.dataset.addonCap||0)||1e9;
    /* "Complete the outfit" follows the newest dress, never an add-on (the adhesive bra) sitting above it */
    const addOns=(rootEl?.dataset.addonHandles||'').split(',').map(x=>x.trim()).filter(Boolean);
    const basis=cart.items.find(i=>!addOns.includes(i.handle))||cart.items[0];
    const cands=await addonCandidates(basis.product_id,rootEl);
    const box2=$('[data-bag-addons]'); if(!box2) return;          /* the bag may have been swapped meanwhile */
    const seen=new Set(), list=cands.filter(p=>p&&p.available!==false&&!inBag.has(p.id)&&!isMens(p.title)&&priceCents(p)<=cap&&!seen.has(p.id)&&seen.add(p.id)).slice(0,4);
    if(!list.length){ box2.hidden=true; box2.innerHTML=''; return; }
    box2.innerHTML='<p class="bag__addons-title">Complete the outfit</p><div class="bag__addons-row">'+list.map(p=>{ const t=splitTitle(p.title), img=p.featured_image?(typeof p.featured_image==='string'?p.featured_image:p.featured_image.url||p.featured_image.src):''; const src=img?img+(img.includes('?')?'&':'?')+'width=200':'';
      return '<div class="bag__addon">'+(src?'<img src="'+esc(src)+'" alt="" width="80" height="100" loading="lazy">':'')+'<a class="bag__addon-name" href="'+esc(rootUrl+'products/'+p.handle)+'">'+esc(t.name)+'</a><span class="bag__addon-price">'+money(priceCents(p))+'</span><button type="button" class="bag__addon-add" data-addon-add data-handle="'+esc(p.handle)+'" aria-label="Add '+esc(t.name)+'"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button></div>'; }).join('')+'</div>';
    box2.hidden=false;
  }
  async function addAddon(btn){
    if(btn.classList.contains('is-loading')) return; btn.classList.add('is-loading');
    try{
      const p=await getJSON(rootUrl+'products/'+encodeURIComponent(btn.dataset.handle)+'.js');
      const avail=p.variants.filter(v=>v.available);
      if(avail.length===1){ const r=await addLine(avail[0].id,1); await maybeAddGift(); await renderShopifyCart(CFG.giftVariantId?null:r); }
      else if(window.__qaOpen){ window.__qaOpen(btn.dataset.handle,btn); }
    }catch(e){ console.error('[cpdp] add-on',e); }
    finally{ btn.classList.remove('is-loading'); }
  }

  /* ---- demo renderer ---- */
  function renderDemoCart(){
    const body=$('.drawer__body'); if(!body) return;
    const sub=demo.items.reduce((s,i)=>s+i.price*i.qty,0);
    body.innerHTML=demo.items.map(demoItemHTML).join('') || '<p class="t-body" style="text-align:center;padding:24px 0;color:var(--c-muted)">Your cart is empty.</p>';
    const co=$('.checkout'); if(co) co.textContent='Checkout · '+moneyF(sub);
    $('.cart-count')&&($('.cart-count').textContent=demo.items.reduce((s,i)=>s+i.qty,0));
    bindQty(body);
    renderRecs();
    renderSavings(demo.items.reduce((s,i)=>s+((i.compareAt&&i.compareAt>i.price)?Math.round((i.compareAt-i.price)*100)*i.qty:0),0));
    $$('.li__remove',body).forEach(b=>b.addEventListener('click',()=>{ demo.items=demo.items.filter(i=>i.__k!==b.dataset.key); applyGiftDemo(); renderDemoCart(); }));
    $$('.li',body).forEach(li=>{ const inp=$('input',li); if(inp) inp.addEventListener('change',()=>{ const it=demo.items.find(i=>i.__k===li.dataset.key); if(it){it.qty=+inp.value||1; applyGiftDemo(); renderDemoCart();} }); });
  }
  function demoItemHTML(i){
    i.__k=i.id+'|'+i.opt;
    const save=(i.compareAt&&i.compareAt>i.price)?`<span class="li__save">(Save ${moneyF((i.compareAt-i.price)*i.qty)})</span>`:'';
    const price=i.gift?`<span class="was">${moneyF(i.compareAt)}</span> <span class="now" style="font-weight:600">$0.00</span> <span class="li__save">Complimentary gift</span>`
      :`${i.compareAt&&i.compareAt>i.price?`<span class="was">${moneyF(i.compareAt)}</span>`:''}<span class="now">${moneyF(i.price)}</span>${save}`;
    const qty=i.gift?'':`<div class="qty"><button data-step="-1">–</button><input value="${i.qty}" inputmode="numeric"><button data-step="1">+</button></div>`;
    return `<div class="li" data-key="${i.__k}"><div class="ph">3:5</div><div class="li__meta">
      <div class="li__name">${i.name}</div><div class="li__opt">${i.opt}</div><div class="li__price">${price}</div>
      <div class="li__row">${qty}${i.gift?'':`<button class="li__remove" data-key="${i.__k}" aria-label="Remove"><svg class="ico" viewBox="0 0 24 24"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg></button>`}</div>
      </div></div>`;
  }
  function cartRecs(){ try{ return JSON.parse(document.getElementById('cpdp-cart-recs')?.textContent||'[]'); }catch(e){ return []; } }
  function ymlHTML(){
    const recs = cartRecs();
    if(!recs.length) return '';
    const cards = recs.map(r=>{
      const vars = r.variants||[];
      const dv = vars.find(v=>v.available) || vars[0];
      if(!dv) return '';
      const dvImg = dv.image || r.image;
      const img = dvImg ? `<img class="yml-img" src="${dvImg}" alt="">` : '<div class="ph"></div>';
      const was = (dv.compareAt && dv.compareAt>dv.price) ? `<span class="was">${money(dv.compareAt)}</span>` : '<span class="was" style="display:none"></span>';
      const name = (r.title||'').split('|')[0].trim();
      const opts = vars.map(v=>`<option value="${v.id}" data-price="${v.price}" data-compare="${v.compareAt||0}" data-img="${v.image||''}"${v.available?'':' disabled'}${v.id===dv.id?' selected':''}>${v.label}${v.available?'':' — Sold out'}</option>`).join('');
      const select = vars.length>1 ? `<select class="yml__select" aria-label="Option">${opts}</select>` : '';
      return `<div class="yml__card">${img}<div class="yml__meta">
        <div class="yml__name">${name}</div>
        <div class="yml__price"><span class="now">${money(dv.price)}</span>${was}</div>
        <div class="yml__cta">${select}<button class="yml__add" data-vid="${dv.id}">Add</button></div></div></div>`;
    }).filter(Boolean).join('');
    if(!cards) return '';
    return `<div class="yml" data-carousel><div class="yml__title">You might like</div><div class="yml__track" data-carousel-track>${cards}</div></div>`;
  }
  function wireYml(body){
    $$('.yml__card',body).forEach(card=>{
      const sel=$('.yml__select',card), add=$('.yml__add',card), now=$('.yml__price .now',card), was=$('.yml__price .was',card), imgEl=$('.yml-img',card);
      sel?.addEventListener('change',()=>{
        const opt=sel.selectedOptions[0]; if(!opt) return;
        if(add) add.dataset.vid=opt.value;
        const p=+opt.dataset.price||0, c=+opt.dataset.compare||0;
        if(now) now.textContent=money(p);
        if(was){ if(c>p){ was.textContent=money(c); was.style.display=''; } else was.style.display='none'; }
        if(imgEl && imgEl.tagName==='IMG' && opt.dataset.img){ imgEl.src=opt.dataset.img; }
      });
      add?.addEventListener('click',async()=>{
        const id=+add.dataset.vid; if(!id) return;
        const orig=add.textContent; add.disabled=true; add.textContent='Adding…';
        try{
          if(window.Shopify){
            await addLine(id,1);
            await maybeAddGift();
            await renderShopifyCart();
          } else {
            const opt=sel?sel.selectedOptions[0]:null;
            upsert({id,name:$('.yml__name',card)?.textContent||'Item',opt:opt?opt.textContent:'',price:(+((opt&&opt.dataset.price)||0))/100,compareAt:(+((opt&&opt.dataset.compare)||0))/100,qty:1});
            applyGiftDemo(); renderDemoCart();
          }
        }catch(e){ console.error('[cpdp] yml add failed',e); add.disabled=false; add.textContent=orig; }
      });
    });
  }

  /* ---- legacy no-ops (demo mode only) ---- */
  function renderRecs(){}
  function renderSavings(){}

  /* ============ BAG open/close: pure CSS, focus moves in and stays in, page behind doesn't scroll ============ */
  const overlay=()=>$('.overlay'), drawer=()=>$('#CartDrawer')||$('.drawer');
  let bagOpener=null;
  function openDrawer(opener){
    const d=drawer(); if(!d) return;
    /* Safari doesn't focus a tapped button, so callers pass what opened the bag */
    if(!d.classList.contains('is-open')) bagOpener=(opener && opener.nodeType===1) ? opener : document.activeElement;
    overlay()?.classList.add('is-open'); d.classList.add('is-open'); document.documentElement.classList.add('bag-open');
    if(!bagSeen){ bagSeen=true; bagMotion(d,'0%',0); }
    setTimeout(()=>{ ($('[data-bag-close]',d)||d).focus({preventScroll:true}); },60);
  }
  /* Shopify's standard "open cart" action (and anything else) can open the bag, freshly rendered */
  window.HMBag={ open:(opener)=>refreshBag().catch(()=>{}).then(()=>openDrawer(opener)) };
  function closeDrawer(){
    const d=drawer(); if(!d||!d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); document.documentElement.classList.remove('bag-open');
    if(!document.querySelector('.qa-sheet.is-open,.sg-modal.is-open,.nav-drawer.is-open,.filter-drawer.is-open')) overlay()?.classList.remove('is-open');
    const o=bagOpener; bagOpener=null; if(o && document.contains(o)) o.focus?.({preventScroll:true});
  }
  /* Tab stays inside the open bag */
  document.addEventListener('keydown',e=>{
    if(e.key!=='Tab') return; const d=drawer(); if(!d||!d.classList.contains('is-open')) return;
    if(document.querySelector('.qa-sheet.is-open')) return;
    const f=$$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])',d).filter(x=>x.offsetParent!==null);
    if(!f.length) return; const first=f[0], last=f[f.length-1];
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    else if(!d.contains(document.activeElement)){ e.preventDefault(); first.focus(); }
  });

  /* ============ GROUP 2 — newsletter modal + search overlay ============ */
  function initNewsletter(){
    const modal=$('.nl-modal'), tab=$('.nl-tab'); if(!modal && !tab) return;
    // Opt-in only: the bottom-right corner bubble is the sole entry point. No wall-on-load,
    // no exit-intent, no page-dimming backdrop — opening the card never takes over the screen.
    const openModal=()=>{ modal?.classList.add('is-open'); tab?.classList.add('is-hidden'); };
    const closeModal=()=>{ modal?.classList.remove('is-open'); tab?.classList.remove('is-hidden'); };
    $('.nl-modal__close',modal)?.addEventListener('click',closeModal);
    $('.nl-modal__decline',modal)?.addEventListener('click',closeModal);
    tab?.addEventListener('click',e=>{ if(e.target.closest('.nl-tab__dismiss')) return; openModal(); });
    $('.nl-tab__dismiss',tab)?.addEventListener('click',e=>{ e.stopPropagation(); tab.classList.add('is-hidden'); });
    modal && (modal.__close=closeModal);
    // hide the pill while near the top so it never covers the buybox trust lines; reveal on scroll
    if(tab){
      const restToggle=()=>{ tab.classList.toggle('nl-tab--rest', (window.scrollY||0) < 460); };
      restToggle(); window.addEventListener('scroll', restToggle, {passive:true});
    }
    // After a successful sign-up the page reloads — open immediately (bypass delay) to reveal the code.
    if(modal && modal.querySelector('[data-nl-success]')) openModal();
    const copyBtn=$('.nl-success__copy',modal);
    copyBtn?.addEventListener('click',()=>{
      const code=copyBtn.dataset.code||'';
      const label=$('.nl-success__copy-label',copyBtn);
      const done=()=>{ copyBtn.classList.add('is-copied'); if(label) label.textContent='Copied!';
        setTimeout(()=>{ copyBtn.classList.remove('is-copied'); if(label) label.textContent='Copy'; },1600); };
      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done).catch(done); } else { done(); }
    });
  }

  function initSearchOverlay(){
    const ov=$('.search-overlay'); if(!ov) return;
    const input=$('input',ov), results=$('.search-overlay__results',ov);
    const open=()=>{ ov.classList.add('is-open'); overlay()?.classList.add('is-open'); document.body.style.overflow='hidden'; setTimeout(()=>input?.focus(),120); };
    const close=()=>{ ov.classList.remove('is-open'); overlay()?.classList.remove('is-open'); document.body.style.overflow=''; };
    $$('.search-open,[data-search-open]').forEach(b=>b.addEventListener('click',e=>{ e.preventDefault(); open(); }));
    $('.search-overlay__close',ov)?.addEventListener('click',close);
    document.addEventListener('keydown',e=>{ if(e.key==='Escape') close(); });
    ov.__close=close;
    // predictive (Shopify) with graceful no-op fallback
    let t;
    input?.addEventListener('input',()=>{
      clearTimeout(t); const q=input.value.trim();
      if(q.length<2){ results.innerHTML=''; return; }
      t=setTimeout(async()=>{
        try{
          const res=await fetch(`${(window.Shopify&&window.routes&&window.routes.predictive_search_url)||'/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=`);
          const data=await res.json();
          const items=(data.resources&&data.resources.results&&data.resources.results.products)||[];
          results.innerHTML=items.map(p=>`<a class="search-suggest" href="${p.url}">${p.featured_image?`<img src="${p.featured_image.url}" alt="">`:'<div class="ph"></div>'}<span><span class="search-suggest__name">${p.title}</span><span class="search-suggest__price">${p.price||''}</span></span></a>`).join('');
        }catch(e){ /* demo / offline: leave results empty */ }
      },220);
    });
  }

  /* ============ QUICK ADD (collection / search / home grids) ============
     "+" on a card opens a sheet with colour swatches + size buttons (nothing preselected
     but the first colour), adds without leaving the grid, then opens the side cart.
     Product data is fetched on tap (/products/<handle>.js), so the grid stays light. */
  function initQuickAdd(){
    let sheet=null, state=null;
    const esc=s=>String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const sized=(u,w)=>{ if(!u) return ''; const s=typeof u==='string'?u:(u.src||''); return s ? s+(s.includes('?')?'&':'?')+'width='+w : ''; };
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    function ensureSheet(){
      if(sheet) return sheet;
      sheet=document.createElement('div');
      sheet.className='qa-sheet'; sheet.setAttribute('role','dialog'); sheet.setAttribute('aria-modal','true'); sheet.setAttribute('aria-label','Quick add');
      document.body.appendChild(sheet);
      sheet.addEventListener('click',onSheetClick);
      return sheet;
    }
    function close(){ if(!sheet||!sheet.classList.contains('is-open')) return; sheet.classList.remove('is-open');
      if(!drawer()?.classList.contains('is-open')){ overlay()?.classList.remove('is-open'); document.body.style.overflow=''; }
      const o=state?.opener; if(o && document.contains(o)) o.focus?.(); }
    function open(){ sheet.classList.add('is-open'); overlay()?.classList.add('is-open'); document.body.style.overflow='hidden'; setTimeout(()=>$('.qa-sheet__close',sheet)?.focus(),60); }
    const optVal=(v,i)=> i<0 ? null : (v.options ? v.options[i] : v['option'+(i+1)]);
    function pick(){
      const {p,ci,si,color,size}=state;
      const m=p.variants.filter(v=>(ci<0||optVal(v,ci)===color)&&(si<0||optVal(v,si)===size));
      return m.find(v=>v.available)||m[0]||null;
    }
    function render(){
      const {p,ci,si,color,size,busy,err}=state;
      const v=(si<0||size)?pick():null;
      const shown=v||p.variants.find(x=>ci<0||optVal(x,ci)===color)||p.variants[0];
      const tt=splitTitle(p.title), name=tt.name;
      const img=sized((shown&&shown.featured_image)||p.featured_image,300);
      const sale=shown.compare_at_price&&shown.compare_at_price>shown.price;
      const colors=ci>=0?p.options[ci].values:[], sizes=si>=0?p.options[si].values:[];
      const swatch=c=>{ const cv=p.variants.find(x=>optVal(x,ci)===c&&x.featured_image); const t=cv?sized(cv.featured_image,104):'';
        return `<button type="button" class="qa-sw" data-color="${esc(c)}" aria-pressed="${c===color}" aria-label="${esc(c)}">${t?`<img src="${esc(t)}" alt="" width="52" height="66" loading="lazy">`:`<span>${esc(c)}</span>`}</button>`; };
      const sizeBtn=s=>{ const ok=p.variants.some(x=>(ci<0||optVal(x,ci)===color)&&optVal(x,si)===s&&x.available);
        return `<button type="button" class="qa-sz" data-size="${esc(s)}" aria-pressed="${s===size}"${ok?'':' disabled'}>${esc(s)}</button>`; };
      sheet.innerHTML=`<button type="button" class="qa-sheet__close" aria-label="Close">&times;</button>
        <div class="qa-sheet__head">${img?`<img src="${esc(img)}" alt="" width="84" height="105">`:''}<div>
          <div class="qa-sheet__title">${esc(name)}</div>${tt.desc?`<div class="qa-sheet__desc">${esc(tt.desc)}</div>`:''}
          <div class="qa-sheet__price"><span>${money(shown.price)}</span>${sale?` <s>${money(shown.compare_at_price)}</s>`:''}</div>
          <a class="qa-sheet__link" href="${esc(p.url||root+'products/'+p.handle)}">View full details</a></div></div>
        ${colors.length>1?`<div class="qa-sheet__label">${esc(p.options[ci].name||'Colour')}: <b>${esc(color)}</b></div><div class="qa-sheet__swatches">${colors.map(swatch).join('')}</div>`:''}
        ${sizes.length?`<div class="qa-sheet__label">${esc(p.options[si].name||'Size')}</div><div class="qa-sheet__sizes">${sizes.map(sizeBtn).join('')}</div>`:''}
        <p class="qa-sheet__err" role="alert"${err?'':' hidden'}>${esc(err||'')}</p>
        <button type="button" class="qa-sheet__add"${busy?' disabled':''}>${busy?'Adding…':(CFG.atcLabel||'Add to Cart')}</button>`;
    }
    async function onSheetClick(e){
      const t=e.target.closest('button'); if(!t||!state) return;
      if(t.classList.contains('qa-sheet__close')) return close();
      if(t.classList.contains('qa-sw')){ state.color=t.dataset.color; state.err='';
        if(state.size && !state.p.variants.some(x=>optVal(x,state.ci)===state.color&&optVal(x,state.si)===state.size&&x.available)) state.size=null;
        return render(); }
      if(t.classList.contains('qa-sz')){ if(t.disabled) return; state.size=t.dataset.size; state.err=''; return render(); }
      if(t.classList.contains('qa-sheet__add')){
        if(state.si>=0 && !state.size){ state.err='Choose your size'; render(); $('.qa-sheet__sizes',sheet)?.scrollIntoView({block:'nearest'}); return; }
        const v=pick(); if(!v||!v.available){ state.err='Sorry, that option is sold out.'; return render(); }
        state.busy=true; state.err=''; render();
        try{
          const r=await addLine(v.id,1); await maybeAddGift();
          await renderShopifyCart(CFG.giftVariantId?null:r);
          const op=state.opener; state.busy=false; close(); openDrawer(op);
        }catch(err){ state.busy=false; state.err=friendlyError(err); render(); }
      }
    }
    document.addEventListener('click',e=>{
      const b=e.target.closest('.pcard__qa'); if(!b) return;
      e.preventDefault(); e.stopPropagation();
      if(b.dataset.qaHandle) openQA(b.dataset.qaHandle,b);
    });
    async function openQA(handle,b){
      b?.classList.add('is-loading');
      try{
        const res=await fetch(root+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}});
        if(!res.ok) throw new Error('product '+res.status);
        const p=await res.json();
        const names=(p.options||[]).map(o=>typeof o==='string'?o:o.name);
        p.options=(p.options||[]).map((o,i)=>typeof o==='string'?{name:o,values:[...new Set(p.variants.map(v=>optVal(v,i)))]}:o);
        const ci=names.findIndex(n=>/colou?r/i.test(n)), si=names.findIndex(n=>/size|gr(ö|o)(ss|ß)e/i.test(n));
        const first=p.variants.find(v=>v.available)||p.variants[0];
        state={p,ci,si,color:ci>=0?optVal(first,ci):null,size:(si>=0&&p.options[si].values.length===1)?p.options[si].values[0]:null,busy:false,err:'',opener:b};
        ensureSheet(); render(); open();
      }catch(err){ console.error('[cpdp] quick add failed',err); window.location.href=root+'products/'+handle; }
      finally{ b?.classList.remove('is-loading'); }
    }
    window.__qaOpen=openQA;
    window.__qaClose=close;
  }

  /* ============ STYLED WITH (buy panel) ============
     custom.styled_with renders server-side; otherwise Shopify's complementary recommendations.
     Hidden when there is nothing to show. */
  function initStyledWith(){
    const box=$('[data-styled-with][data-fetch]'); if(!box) return;
    fetch(box.dataset.fetch).then(r=>r.ok?r.json():Promise.reject(r.status)).then(d=>{
      const list=(d.products||[]).filter(p=>p.available && p.handle!==CFG.handle).slice(0,3);
      if(!list.length) return;
      $('[data-styled-list]',box).innerHTML=list.map(p=>{ const img=p.featured_image?(p.featured_image+(String(p.featured_image).includes('?')?'&':'?')+'width=96'):'';
        return `<a class="styledwith__chip" href="${esc(p.url)}">${img?`<img src="${esc(img)}" alt="" width="32" height="40" loading="lazy">`:''}<span>${esc(splitTitle(p.title).name)}</span></a>`; }).join('');
      box.hidden=false;
    }).catch(()=>{});
  }

  /* ============ COMPLETE THE LOOK ============
     Rows: the current piece + up to N pieces (styled_with → chosen collection → auto-picked women's
     layers). Each row: checkbox, thumb, two-part name, price, inline Colour / Size pill pickers.
     Running total with the real multi-buy saving; one button adds every ticked piece. */
  function initLook(){
    const sec=$('[data-look]'); if(!sec) return;
    const list=$('[data-look-list]',sec), totalEl=$('[data-look-total]',sec), wasEl=$('[data-look-was]',sec),
          saveEl=$('[data-look-saving]',sec), errEl=$('[data-look-error]',sec), addBtn=$('[data-look-add]',sec);
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    let handles=[]; try{ handles=JSON.parse($('[data-look-data]',sec).textContent||'[]'); }catch(e){}
    const limit=+sec.dataset.limit||2, current=sec.dataset.current;
    const rows=[]; let bagCount=0, started=false;
    const getJSON=u=>fetch(u,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():Promise.reject(r.status));
    const optIdxOf=(p,re)=>(p.options||[]).findIndex(o=>re.test(typeof o==='string'?o:o.name));
    const valsOf=(p,i)=>{ const o=p.options[i]; return (o&&o.values)?o.values:[...new Set(p.variants.map(v=>v.options[i]))]; };
    const isMens=t=>/\bmen'?s?\b|\bmens\b/i.test(t) && !/women/i.test(t);
    async function autoPick(){
      const found=[];
      for(const p of await dressCandidates(sec.dataset.productId||'',sec.dataset.fallback||'')){ if(found.length>=limit) break; if(p.handle!==current&&!found.includes(p.handle)) found.push(p.handle); }
      return found;
    }
    function rowState(p,isCurrent){
      const ci=optIdxOf(p,/colou?r/i), si=optIdxOf(p,/size|gr(ö|o)(ss|ß)e/i);
      const first=p.variants.find(v=>v.available)||p.variants[0];
      let color=ci>=0?first.options[ci]:null, size=null;
      if(isCurrent){ if(variant.color) color=variant.color; if(variant.size) size=variant.size; }
      if(si>=0 && valsOf(p,si).length===1) size=valsOf(p,si)[0];
      return {p,ci,si,color,size,on:true,open:null,err:'',isCurrent};
    }
    const pick=r=>{ const m=r.p.variants.filter(v=>(r.ci<0||v.options[r.ci]===r.color)&&(r.si<0||!r.size||v.options[r.si]===r.size)); return (r.si>=0&&!r.size)?null:(m.find(v=>v.available)||m[0]||null); };
    const priceOf=r=>{ const v=pick(r)||r.p.variants.find(x=>(r.ci<0||x.options[r.ci]===r.color))||r.p.variants[0]; return v.price; };
    function rowHTML(r,i){
      const t=splitTitle(r.p.title), v=pick(r)||r.p.variants.find(x=>r.ci<0||x.options[r.ci]===r.color)||r.p.variants[0];
      const img=(v.featured_image&&v.featured_image.src)||r.p.featured_image;
      const thumb=img?String(img)+(String(img).includes('?')?'&':'?')+'width=160':'';
      const colors=r.ci>=0?valsOf(r.p,r.ci):[], sizes=r.si>=0?valsOf(r.p,r.si):[];
      const sizeOk=s=>r.p.variants.some(x=>(r.ci<0||x.options[r.ci]===r.color)&&x.options[r.si]===s&&x.available);
      const picker=(kind,label,val,opts,isOk)=>`<div class="look__pick"><button type="button" class="look__toggle${r.open===kind?' is-open':''}" data-row="${i}" data-toggle="${kind}" aria-expanded="${r.open===kind}">${esc(label)} · ${val?esc(val):'Choose'}<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>${r.open===kind?`<div class="look__pills" role="group" aria-label="${esc(label)}">${opts.map(o=>`<button type="button" class="look__pill${isOk&&!isOk(o)?' is-soldout':''}" data-row="${i}" data-set="${kind}" data-val="${esc(o)}" aria-pressed="${o===val}">${esc(o)}</button>`).join('')}</div>`:''}</div>`;
      return `<li class="look__row${r.on?'':' is-off'}">
        <label class="look__check"><input type="checkbox" data-row="${i}" ${r.on?'checked':''} aria-label="Include ${esc(t.name)}"><span aria-hidden="true"></span></label>
        ${thumb?`<img class="look__thumb" src="${esc(thumb)}" alt="" width="64" height="80" loading="lazy">`:''}
        <div class="look__info">
          <a class="look__name" href="${esc(r.p.url||root+'products/'+r.p.handle)}">${esc(t.name)}</a>${t.desc?`<span class="look__desc">${esc(t.desc)}</span>`:''}
          <span class="look__price">${money(v.price)}${r.isCurrent?' <em>This piece</em>':''}</span>
          <div class="look__pickers">
            ${colors.length>1?picker('color',r.p.options[r.ci].name||'Colour',r.color,colors):''}
            ${sizes.length?picker('size',r.p.options[r.si].name||'Size',r.size,sizes,sizeOk):''}
          </div>
          ${r.err?`<p class="look__rowerr" role="alert">${esc(r.err)}</p>`:''}
        </div></li>`;
    }
    function render(){
      list.innerHTML=rows.map(rowHTML).join('');
      const on=rows.filter(r=>r.on), sum=on.reduce((a,r)=>a+priceOf(r),0);
      const n=on.length, all=bagCount+n, tiers=getTiers(), top=tiers[tiers.length-1];
      let pct=0; if(tiers.length && n>0 && all<=top.n){ const h=tiers.filter(t=>all>=t.n).pop(); pct=h?h.pct:0; }
      const save=Math.round(sum*pct/100);
      totalEl.textContent=money(sum-save);
      if(save>0){ wasEl.textContent=money(sum); wasEl.hidden=false; saveEl.innerHTML='Multi-buy saving: <strong>'+money(save)+'</strong> ('+pct+'% off, applied automatically)'; saveEl.hidden=false; }
      else if(tiers.length && n>0 && all>top.n){ wasEl.hidden=true; saveEl.textContent='Multi-buy savings apply automatically in your bag.'; saveEl.hidden=false; }
      else { wasEl.hidden=true; saveEl.hidden=true; }
      addBtn.disabled=n===0;
    }
    list.addEventListener('click',e=>{
      const b=e.target.closest('button'); if(!b) return;
      const r=rows[+b.dataset.row]; if(!r) return;
      if(b.dataset.toggle){ r.open=r.open===b.dataset.toggle?null:b.dataset.toggle; return render(); }
      if(b.dataset.set==='color'){ r.color=b.dataset.val; if(r.size && !r.p.variants.some(x=>x.options[r.ci]===r.color&&x.options[r.si]===r.size&&x.available)) r.size=null; r.open=null; r.err=''; return render(); }
      if(b.dataset.set==='size'){ r.size=b.dataset.val; r.open=null; r.err=''; return render(); }
    });
    list.addEventListener('change',e=>{ const c=e.target.closest('input[type=checkbox]'); if(!c) return; const r=rows[+c.dataset.row]; if(r){ r.on=c.checked; render(); } });
    addBtn.addEventListener('click',async()=>{
      errEl.hidden=true; let bad=false;
      const items=[];
      rows.forEach(r=>{ if(!r.on) return; r.err='';
        if(r.si>=0 && !r.size){ r.err='Choose your size'; r.open='size'; bad=true; return; }
        const v=pick(r); if(!v||!v.available){ r.err='Sorry, that option is sold out.'; bad=true; return; }
        items.push({id:v.id,quantity:1}); });
      render();
      if(bad){ $('.look__rowerr',list)?.closest('.look__row')?.scrollIntoView({behavior:'smooth',block:'center'}); return; }
      addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy','true');
      try{ const r=await addItems(items); await maybeAddGift(); await renderShopifyCart(CFG.giftVariantId?null:r); openDrawer(addBtn); }
      catch(err){ errEl.textContent=friendlyError(err); errEl.hidden=false; }
      finally{ addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy'); }
    });
    /* keep the current piece in step with the main buy box, and the saving with the bag */
    window.__lookSync=()=>{ const r=rows.find(x=>x.isCurrent); if(r){ if(variant.color) r.color=variant.color; if(variant.size) r.size=variant.size; render(); } };
    window.__lookBag=(c)=>{ bagCount=c||0; if(rows.length) render(); };
    async function start(){
      if(started) return; started=true;
      try{
        let hs=handles.slice(1);
        const cur=await getJSON(root+'products/'+encodeURIComponent(handles[0]||current)+'.js');
        if(!hs.length && sec.dataset.dresses) hs=await autoPick();
        const others=(await Promise.all(hs.slice(0,limit).map(h=>getJSON(root+'products/'+encodeURIComponent(h)+'.js').catch(()=>null)))).filter(p=>p&&p.available&&!isMens(p.title));
        if(!others.length) return;   /* nothing that goes with it: the section stays hidden */
        window.__lookPicks=others.map(p=>p.handle);   /* the upsell row skips these */
        window.__dedupeUpsell&&window.__dedupeUpsell();
        rows.push(rowState(cur,true)); others.forEach(p=>rows.push(rowState(p,false)));
        try{ bagCount=pieceCount(await getJSON('/cart.js')); }catch(e){}
        render(); sec.hidden=false;
      }catch(e){ console.error('[cpdp] complete the look',e); }
    }
    /* load only once the shopper scrolls near it: the section is hidden until it has rows, so watch its
       (zero-height) Shopify section wrapper, which IntersectionObserver still reports */
    if('IntersectionObserver' in window){ const io=new IntersectionObserver(es=>{ if(es.some(x=>x.isIntersecting)){ io.disconnect(); start(); } },{rootMargin:'400px 0px'});
      io.observe(sec.closest('.shopify-section')||sec.parentElement||document.body); }
    else start();
  }

  /* ============ RECENTLY VIEWED (browser only) ============ */
  function initRecent(){
    const KEY='hm_recent_v1';
    let list=[]; try{ list=JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ list=[]; }
    if(SHOPIFY && CFG.handle){
      const me={h:CFG.handle,t:CFG.title,i:CFG.image,p:CFG.price,c:CFG.compareAt};
      list=[me].concat(list.filter(x=>x&&x.h!==CFG.handle)).slice(0,12);
      try{ localStorage.setItem(KEY,JSON.stringify(list)); }catch(e){}
    }
    const sec=$('[data-recent]'); if(!sec) return;
    const others=list.filter(x=>x&&x.h&&x.h!==sec.dataset.current).slice(0,8);
    if(!others.length) return;
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    $('[data-recent-track]',sec).innerHTML=others.map(x=>{ const t=splitTitle(x.t);
      return `<a class="recent__card" href="${esc(root+'products/'+x.h)}">${x.i?`<img src="${esc(x.i)}" alt="" width="150" height="188" loading="lazy">`:''}<span class="recent__name">${esc(t.name)}</span><span class="recent__price">${x.p?money(x.p):''}${x.c&&x.c>x.p?` <s>${money(x.c)}</s>`:''}</span></a>`; }).join('');
    sec.hidden=false;
  }

  /* ============ DESKTOP BUY PANEL stays in view ============
     Sticky at the top when it fits; when it's taller than the window it sticks by its bottom
     edge instead, so every part of it stays reachable while the image grid scrolls. */
  function initPanelSticky(){
    const bb=$('.buybox'); if(!bb) return;
    const mq=window.matchMedia('(min-width:768px)');
    const set=()=>{ if(!mq.matches){ bb.style.removeProperty('--bb-top'); return; }
      const h=bb.offsetHeight, room=window.innerHeight-24, top=h>room-80 ? Math.min(90, room-h) : 90;
      bb.style.setProperty('--bb-top', top+'px'); };
    set(); window.addEventListener('resize',set,{passive:true}); window.addEventListener('load',set,{once:true});
    if('ResizeObserver' in window) new ResizeObserver(set).observe(bb);
  }

  /* ============ SHOP PAGE (desktop): filters, sort, density, Load more without reloads ============
     Phones keep the drawer (Apply reloads) and numbered pages. On ≥1024px the sidebar / filter bar,
     chips, sort and "Load more" fetch only this section (?section_id=…), swap [data-plp-results] and
     the sidebar, update the URL with history.replaceState, and leave the scroll position alone. */
  const isDeskPLP=()=>window.matchMedia('(min-width:1024px)').matches;
  function pageScroller(){ const pw=$('.page-wrapper'); if(pw && pw.scrollHeight>pw.clientHeight+2 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) return pw; return document.scrollingElement||document.documentElement; }
  function initPLP(){
    const plp=$('[data-plp]'); if(!plp) return;
    const sid=plp.dataset.section;
    const KEY='hm_plp_'+location.pathname;
    let busy=null;
    const paramsFromForm=()=>{ const f=$('[data-facets-form]',plp); const p=new URLSearchParams(f?new FormData(f):undefined);
      [...p.keys()].forEach(k=>{ if(p.get(k)==='') p.delete(k); });
      /* a price range that spans the whole range isn't a filter */
      $$('[data-facets-form] .price-range',plp).forEach(pr=>{ const lo=$(pr.dataset.minInput), hi=$(pr.dataset.maxInput), max=+($('input[data-role="max"]',pr)?.max||0);
        if(lo && (+lo.value||0)<=0) p.delete(lo.name); if(hi && (hi.value===''||+hi.value>=max)) p.delete(hi.name); }); const cur=new URLSearchParams(location.search); if(cur.get('sort_by')) p.set('sort_by',cur.get('sort_by')); return p; };
    const openState=()=>{ const st={}; $$('[data-facets-side] details[data-facet]',plp).forEach(d=>st[d.dataset.facet]=d.open); return st; };
    async function render(params,{push=true}={}){
      const u=new URL(location.pathname,location.origin); params.forEach((v,k)=>{ if(k!=='page'&&k!=='section_id') u.searchParams.append(k,v); });
      const shown=new URL(u); u.searchParams.set('section_id',sid);
      if(busy) busy.abort(); busy=new AbortController();
      plp.classList.add('is-loading');
      try{
        const html=await (await fetch(u,{signal:busy.signal})).text();
        const doc=new DOMParser().parseFromString(html,'text/html');
        const st=openState();
        const fr=doc.querySelector('[data-plp-results]'), fs=doc.querySelector('[data-facets-side]');
        if(fr) $('[data-plp-results]',plp).replaceWith(fr);
        if(fs && $('[data-facets-side]',plp)){ $('[data-facets-side]',plp).replaceWith(fs); $$('[data-facets-side] details[data-facet]',plp).forEach(d=>{ if(d.dataset.facet in st) d.open=st[d.dataset.facet]; }); initPriceRange(); }
        if(push) history.replaceState(history.state,'',shown.pathname+shown.search);
        try{ sessionStorage.removeItem(KEY+shown.search); }catch(e){}
        afterResults();
      }catch(e){ if(e.name!=='AbortError'){ console.error('[cpdp] filter',e); location.href=shown.toString(); } }
      finally{ plp.classList.remove('is-loading'); }
    }
    function afterResults(){ initProductCards(plp); applyCols(); initSortDD(); }
    /* sidebar / bar inputs */
    let t=null;
    plp.addEventListener('change',e=>{ if(!isDeskPLP()) return; if(!e.target.closest('[data-facets-form]')) return;
      clearTimeout(t); t=setTimeout(()=>render(paramsFromForm()), e.target.matches('[data-price-input],input[type=range]')?450:60); });
    plp.addEventListener('input',e=>{ if(!isDeskPLP()) return; if(e.target.matches('[data-facets-form] input[type=range]')){ clearTimeout(t); t=setTimeout(()=>render(paramsFromForm()),500); } });
    /* chips, clear all, "clear filters" */
    plp.addEventListener('click',e=>{ const a=e.target.closest('a[data-plp-link]'); if(!a||!isDeskPLP()) return; e.preventDefault(); const u=new URL(a.href,location.origin); render(u.searchParams); });
    /* Load more: append the next page, keep Showing X of Y + ?page= in step, remember for Back */
    plp.addEventListener('click',async e=>{
      const a=e.target.closest('[data-plp-next]'); if(!a||!isDeskPLP()) return; e.preventDefault();
      if(a.classList.contains('is-loading')) return; a.classList.add('is-loading');
      try{ await loadPage(new URL(a.href,location.origin)); remember(false); }
      catch(err){ console.error('[cpdp] load more',err); location.href=a.href; }
      finally{ a.classList.remove('is-loading'); }
    });
    async function loadPage(url,{prepend=false}={}){
      url.searchParams.set('section_id',sid);
      const doc=new DOMParser().parseFromString(await (await fetch(url)).text(),'text/html');
      const grid=$('[data-plp-grid]',plp), cards=[...doc.querySelectorAll('[data-plp-grid] > .pcard')];
      if(prepend) grid.prepend(...cards); else grid.append(...cards);
      const more=doc.querySelector('[data-plp-more]'), mine=$('[data-plp-more]',plp);
      if(!prepend && more && mine){ mine.replaceWith(more); }
      const page=+url.searchParams.get('page')||1;
      const shown=new URL(location.href); if(!prepend){ shown.searchParams.set('page',page); history.replaceState(history.state,'',shown.pathname+shown.search); }
      if(!prepend){ const s=$('[data-plp-showing]',plp); const total=+(plp.dataset.total||0); if(s && total){ const n=$$('[data-plp-grid] > .pcard',plp).length; s.textContent='Showing '+Math.min(n,total)+' of '+total; } }
      initProductCards(plp);
    }
    let clickSaved=0;
    function remember(fromClick){
      /* a save from the product click wins: the theme's page transition can scroll the card before the page unloads */
      if(fromClick!==true && Date.now()-clickSaved<4000) return;
      if(fromClick===true) clickSaved=Date.now();
      /* also note which card sat at the top, and where: Back puts that card back in the same place even if
         fonts or images settle after the page renders */
      const sc=pageScroller(), top=sc===document.scrollingElement?0:sc.getBoundingClientRect().top;
      const cards=$$('[data-plp-grid] > .pcard',plp); let idx=-1, off=0;
      for(let i=0;i<cards.length;i++){ const r=cards[i].getBoundingClientRect(); if(r.bottom>top+1){ idx=i; off=r.top-top; break; } }
      try{ sessionStorage.setItem(KEY+location.search,JSON.stringify({y:sc.scrollTop,idx,off,t:Date.now()})); }catch(e){}
    }
    /* Back from a product: same filters (they're in the URL), same pages, same scroll */
    async function restore(){
      if(!isDeskPLP()) return;
      const cur=new URL(location.href), page=+cur.searchParams.get('page')||1;
      let saved=null; try{ saved=JSON.parse(sessionStorage.getItem(KEY+location.search)||'null'); }catch(e){}
      if(page>1){ for(let pg=page-1; pg>=1; pg--){ const u=new URL(location.pathname,location.origin); cur.searchParams.forEach((v,k)=>{ if(k!=='page') u.searchParams.append(k,v); }); if(pg>1) u.searchParams.set('page',pg); await loadPage(u,{prepend:true}); }
        const s=$('[data-plp-showing]',plp), total=+(plp.dataset.total||0); if(s&&total) s.textContent='Showing '+Math.min($$('[data-plp-grid] > .pcard',plp).length,total)+' of '+total; }
      if(saved && Date.now()-saved.t<30*60*1000) requestAnimationFrame(()=>{
        /* instant, never the scroller's smooth scrolling: Back should land, not glide */
        const sc=pageScroller(), jump=y=>sc.scrollTo({top:y,behavior:'instant'}); jump(saved.y);
        if(!(saved.idx>=0)) return;
        const anchor=()=>{ const c=$$('[data-plp-grid] > .pcard',plp)[saved.idx]; if(!c) return; const top=sc===document.scrollingElement?0:sc.getBoundingClientRect().top; const d=c.getBoundingClientRect().top-top-saved.off; if(Math.abs(d)>1) jump(sc.scrollTop+d); };
        anchor();
        /* keep that card pinned while late layout settles (fonts swapping in, images), until the shopper scrolls */
        const grid=$('[data-plp-grid]',plp); if(!grid||!('ResizeObserver' in window)) return;
        let done=false; const stop=()=>{ if(done) return; done=true; ro.disconnect(); ['wheel','touchstart','keydown','mousedown'].forEach(t=>removeEventListener(t,stop,true)); };
        const ro=new ResizeObserver(()=>{ if(!done) anchor(); }); ro.observe(grid);
        ['wheel','touchstart','keydown','mousedown'].forEach(t=>addEventListener(t,stop,{capture:true,passive:true}));
        setTimeout(stop,5000);
      });
    }
    /* remember the scroll position when leaving for a product */
    plp.addEventListener('click',e=>{ if(e.target.closest('.pcard a[href*="/products/"]')) remember(true); },true);
    window.addEventListener('pagehide',remember);
    /* sort dropdown (desktop) */
    function initSortDD(){
      const dd=$('[data-sortdd]',plp); if(!dd||dd.__b) return; dd.__b=1;
      const btn=$('.sortdd__btn',dd), list=$('.sortdd__list',dd);
      const close=()=>{ list.hidden=true; btn.setAttribute('aria-expanded','false'); };
      const open=()=>{ list.hidden=false; btn.setAttribute('aria-expanded','true'); ($('[aria-selected="true"]',list)||$('li',list))?.focus(); };
      btn.addEventListener('click',()=> list.hidden?open():close());
      list.addEventListener('click',e=>{ const li=e.target.closest('li'); if(!li) return; close(); const p=paramsFromForm(); p.set('sort_by',li.dataset.value); const u=new URL(location.href); u.searchParams.set('sort_by',li.dataset.value); history.replaceState(history.state,'',u.pathname+u.search); render(p); });
      list.addEventListener('keydown',e=>{ const items=$$('li',list), i=items.indexOf(document.activeElement);
        if(e.key==='ArrowDown'){ e.preventDefault(); items[Math.min(i+1,items.length-1)].focus(); }
        else if(e.key==='ArrowUp'){ e.preventDefault(); items[Math.max(i-1,0)].focus(); }
        else if(e.key==='Enter'||e.key===' '){ e.preventDefault(); document.activeElement.click(); }
        else if(e.key==='Escape'){ close(); btn.focus(); } });
      document.addEventListener('click',e=>{ if(!dd.contains(e.target)) close(); });
    }
    /* desktop density 3 / 4, remembered */
    function applyCols(){ let c='4'; try{ c=localStorage.getItem('hm_plp_cols')||'4'; }catch(e){}
      const g=$('[data-plp-grid]',plp); if(g) g.dataset.cols=c; $$('[data-cols]',plp).forEach(b=>b.setAttribute('aria-pressed',b.dataset.cols===c?'true':'false')); }
    plp.addEventListener('click',e=>{ const b=e.target.closest('[data-cols]'); if(!b) return; try{ localStorage.setItem('hm_plp_cols',b.dataset.cols); }catch(err){} applyCols(); });
    applyCols(); initSortDD(); restore();
  }

  /* ============ CARD (desktop): swatches switch the image; hover panel adds a size in one click ============ */
  const cardProduct={};
  function cardJSON(handle){ if(!cardProduct[handle]) cardProduct[handle]=getJSON(rootUrl+'products/'+encodeURIComponent(handle)+'.js').catch(e=>{ delete cardProduct[handle]; throw e; }); return cardProduct[handle]; }
  function initCards(){
    /* colour swatches: hover (desktop) or click switches the card image, no navigation */
    const swap=(dot)=>{ const card=dot.closest('[data-card]'); if(!card) return;
      $$('.pcard__dot',card).forEach(d=>d.removeAttribute('aria-current')); dot.setAttribute('aria-current','true'); card.dataset.color=dot.dataset.color||'';
      const img=$('.pcard__img--main',card); if(img && dot.dataset.src){ img.srcset=dot.dataset.srcset||''; img.src=dot.dataset.src; } };
    document.addEventListener('click',e=>{ const d=e.target.closest('.pcard__dot'); if(!d) return; e.preventDefault(); swap(d); });
    document.addEventListener('mouseover',e=>{ const d=e.target.closest('.pcard__dot'); if(d && window.matchMedia('(hover:hover)').matches) swap(d); });
    /* warm the product data while the shopper hovers, so a size click is one request */
    document.addEventListener('mouseover',e=>{ const c=e.target.closest('[data-card]'); if(c && !c.__warm && window.matchMedia('(hover:hover) and (min-width:1024px)').matches){ c.__warm=1; cardJSON(c.dataset.handle).catch(()=>{}); } });
    document.addEventListener('click',async e=>{
      const b=e.target.closest('[data-hq-size]'); if(!b) return; e.preventDefault(); e.stopPropagation();
      const card=b.closest('[data-card]'), msg=$('.pcard__hoverqa-msg',card); if(b.classList.contains('is-loading')) return;
      b.classList.add('is-loading');
      try{
        const p=await cardJSON(card.dataset.handle);
        const names=(p.options||[]).map(o=>typeof o==='string'?o:o.name);
        const ci=names.findIndex(n=>/colou?r/i.test(n)), si=names.findIndex(n=>/size|gr(ö|o)(ss|ß)e/i.test(n));
        const color=card.dataset.color || ($('.pcard__dot[aria-current="true"]',card)?.dataset.color) || null;
        const size=b.dataset.hqSize||null;
        const m=p.variants.filter(v=>(ci<0||!color||v.options[ci]===color)&&(si<0||!size||v.options[si]===size));
        const v=m.find(x=>x.available)||null;
        if(!v){ if(msg) msg.textContent='Sold out in '+(size||'this option'); return; }
        const r=await addLine(v.id,1); await maybeAddGift(); await renderShopifyCart(CFG.giftVariantId?null:r);
        card.classList.add('is-added'); if(msg) msg.textContent='Added'; setTimeout(()=>{ card.classList.remove('is-added'); if(msg) msg.textContent=''; },2200);
        openDrawer(b);
      }catch(err){ if(msg) msg.textContent=friendlyError(err); }
      finally{ b.classList.remove('is-loading'); }
    });
  }

  /* ============ FOOTER (desktop): accordions become always-open columns; phones keep the accordions ============ */
  function initFooter(){
    const f=$('[data-footer]'); if(!f) return;
    const mq=window.matchMedia('(min-width:1024px)');
    const sync=()=>{ $$('details.footer__acc',f).forEach(d=>{ if(mq.matches){ d.open=true; d.dataset.cols='1'; const pn=$('.acc__panel',d); if(pn) pn.style.height='auto'; } else if(d.dataset.cols){ d.open=false; delete d.dataset.cols; const pn=$('.acc__panel',d); if(pn) pn.style.height=''; } }); };
    f.addEventListener('click',e=>{ if(mq.matches && e.target.closest('details.footer__acc > summary')){ e.preventDefault(); e.stopImmediatePropagation(); } },true);
    sync(); mq.addEventListener?.('change',sync);
  }

  /* ============ CONTENT PAGES (desktop): sticky "On this page" built from the page's own headings ============ */
  function initTOC(){
    const body=$('.richpage__body'); if(!body) return;
    if(!window.matchMedia('(min-width:1024px)').matches) return;
    let heads=$$('h2,h3',body).filter(h=>h.textContent.trim().length>1);
    if(heads.length<3) heads=$$('p',body).filter(p=>p.children.length===1 && p.firstElementChild.tagName==='STRONG' && p.textContent.trim()===p.firstElementChild.textContent.trim() && p.textContent.trim().length<70);
    if(heads.length<3) return;
    const sec=body.closest('.richpage'); if(!sec) return;
    const toc=document.createElement('nav'); toc.className='richpage__toc'; toc.setAttribute('aria-label','On this page');
    toc.innerHTML='<p class="richpage__toc-title">On this page</p><ol>'+heads.map((h,i)=>{ if(!h.id) h.id='s-'+(i+1)+'-'+h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').slice(0,40); return '<li><a href="#'+h.id+'">'+esc(h.textContent.trim())+'</a></li>'; }).join('')+'</ol>';
    sec.classList.add('richpage--toc'); body.before(toc);
    toc.addEventListener('click',e=>{ const a=e.target.closest('a'); if(!a) return; e.preventDefault(); const t=document.getElementById(a.getAttribute('href').slice(1)); t?.scrollIntoView({behavior:'smooth',block:'start'}); history.replaceState(history.state,'',a.getAttribute('href')); });
  }

  /* ============ init ============ */
  document.addEventListener('DOMContentLoaded',()=>{
    initGallery(); initImageZoom(); initSelectors(); initAccordions(); initCarousels(); initStickyBar(); bindQty();
    initHero(); initNavDrawer(); initHeaderReveal(); initAovBar();
    initFilterDrawer(); initDensityToggle(); initProductCards(); initPriceRange();
    initNewsletter(); initSearchOverlay(); initUgcVideos(); initUpsellCards(); initUpsellRecs(); initSizeGuide(); initQuickAdd();
    initStyledWith(); initLook(); initRecent(); initPanelSticky(); initPLP(); initCards(); initFooter(); initTOC();
    $('#primary-atc')?.addEventListener('click',addToCart);
    initAddon();
    $('#buy-now')?.addEventListener('click',buyNow);
    $$('.cart-btn').forEach(b=>b.addEventListener('click',e=>{ e.preventDefault(); openDrawer(b); }));
    initBag();
    overlay()?.addEventListener('click',closeAllOverlays);
    document.addEventListener('keydown',e=>{ if(e.key!=='Escape') return;
      if(document.querySelector('.zoomview.is-open')){ window.__zoomClose&&window.__zoomClose(); return; }
      if(document.querySelector('.drawer.is-open,.sg-modal.is-open,.nav-drawer.is-open,.filter-drawer.is-open,.qa-sheet.is-open')) closeAllOverlays(); });
  });
})();
